<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>

              <b-dropdown right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom
                          title="Opciones de Edición"
                          v-if="access.elements.changeProductsSale && !statusEditPrice">
                <template #button-content>
                  <AppIcon name="tune" label="Opciones de Edición" />
                </template>
                <b-dropdown-item @click="addProduct()">
                  <AppIcon name="add" /> Agregar Producto
                </b-dropdown-item>
                <b-dropdown-item @click="openImportEditorCreate()">
                  <AppIcon name="list-ul" /> Agregar lotes de productos
                </b-dropdown-item>

                <b-dropdown-divider v-if="hasShowPriceSales"></b-dropdown-divider>
                <b-dropdown-item @click="selectPriceSalesDefault()" v-if="hasShowPriceSales">
                  <AppIcon name="currency-dollar" /> Precio de Venta por Defecto
                </b-dropdown-item>

                <b-dropdown-divider v-if="itemSelected"></b-dropdown-divider>
                <b-dropdown-item @click="initChangePrice()" v-if="itemSelected">
                  <AppIcon name="edit" /> Edición Múltiple
                </b-dropdown-item>

                <b-dropdown-divider v-if="itemSelected"></b-dropdown-divider>
                <b-dropdown-item @click="showEditPriceLote()" v-if="itemSelected" title="Modifica el precio de lista de todos los productos filtrados">
                  <AppIcon name="percent" /> Edición general de precios
                </b-dropdown-item>
                <b-dropdown-item @click="showEditDiscountLote()" v-if="itemSelected" title="Agrega el mismo descuento a todos los productos filtrados">
                  <AppIcon name="sell" /> Edición general de descuentos
                </b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="openImportCSV()">
                  <AppIcon name="file-earmark-spreadsheet" /> Importaciones
                </b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="snapshotOffline.active = true" :disabled="snapshotOffline.loading">
                  <AppIcon name="cloud_download" /> Actualizar precios modo offline
                </b-dropdown-item>
              </b-dropdown>

              <b-dropdown right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary cpls-options-toggle--warning"
                          v-b-tooltip.hover.bottom
                          title="Opciones de Edición"
                          v-if="access.elements.changeProductsSale && statusEditPrice">
                <template #button-content>
                  <AppIcon name="tune" label="Opciones de Edición" />
                </template>
                <b-dropdown-item @click="selectPriceSalesDefault()" v-if="hasShowPriceSales">
                  <AppIcon name="currency-dollar" /> Precio de Venta por Defecto
                </b-dropdown-item>
                <b-dropdown-divider v-if="hasShowPriceSales"></b-dropdown-divider>

                <b-dropdown-item @click="showEditPriceLote()" v-if="itemSelected" title="Modifica el precio de lista de todos los productos filtrados">
                  <AppIcon name="percent" /> Edición general de precios
                </b-dropdown-item>
                <b-dropdown-item @click="showEditDiscountLote()" v-if="itemSelected" title="Agrega el mismo descuento a todos los productos filtrados">
                  <AppIcon name="sell" /> Edición general de descuentos
                </b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="endChangePrice()" title="Finaliza el modo de edición de precios múltiples">
                  <AppIcon name="x" /> Finalizar edición múltiple
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters" v-if="hasProductsToFilter">
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 320px;">
              <label class="filter-label">Buscar</label>
              <b-form-input type="text" size="sm" placeholder="Código, nombre o referencia externa" v-model="filterQuery.text" v-on:keyup.enter.native="applyProductFilters()"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 170px; max-width: 220px;">
              <label class="filter-label">Referencia Externa</label>
              <v-select :options="arr.select.haveReferenceExternal" v-model="filterQuery.haveReferenceExternal" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 170px; max-width: 220px;">
              <label class="filter-label">Producto Vinculado</label>
              <v-select :options="arr.select.linkedProduct" v-model="filterQuery.linkedProduct" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 170px; max-width: 220px;">
              <label class="filter-label">No Importados</label>
              <v-select :options="arr.select.notImported" v-model="filterQuery.notImported" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Última Actualización</label>
              <b-form-select size="sm" :options="arr.select.lastUpdate" v-model="filterQuery.lastUpdate"></b-form-select>
            </div>
            <b-button variant="outline-dark"
                      size="sm"
                      @click="applyProductFilters()"
                      v-b-tooltip.hover
                      title="Aplicar filtros"
                      style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
          <div class="app-alert app-alert--info cpls-filters-hint" v-else>
            <span class="app-alert__icon"><AppIcon name="info" /></span>
            <div class="app-alert__content">
              <template v-if="!itemSelected">Estos filtros se aplican sobre los productos de un proveedor — elegí uno en el panel de la izquierda para poder usarlos.</template>
              <template v-else>El proveedor seleccionado no tiene productos cargados para filtrar.</template>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col v-if="!statusEditPrice && !treeCollapsed" lg="3">
          <b-card no-body id="cost-tree-suppliers">
            <div class="cost-tree-panel-title">
              <span><AppIcon name="group" /> Proveedores</span>
              <b-button variant="link" class="cost-tree-toggle" size="sm" @click="treeCollapsed = true" v-b-tooltip.hover title="Minimizar panel" aria-label="Minimizar panel">
                <AppIcon name="chevron_left" />
              </b-button>
            </div>
            <div class="cost-tree-panel-filter">
              <v-select :options="arr.filters.suppliers" v-model="filters.suppliers" placeholder="Filtrar proveedores..." :multiple="true" :select-on-tab="true"></v-select>
              <b-button variant="outline-dark" size="sm" @click="loadSuppliers()" v-b-tooltip.hover title="Aplicar filtro">
                <AppIcon name="filter" />
              </b-button>
            </div>
            <div class="cost-tree-suppliers-tree" :class="{ 'cost-tree-suppliers-tree--loading': table.isBusy }">
              <div class="cost-tree-suppliers-tree__overlay" v-if="table.isBusy">
                <b-spinner small class="align-middle"></b-spinner>
              </div>
              <vue-tree-list
                @click="selectedItem"
                :model="suppliersTree"
                v-bind:default-expanded="false"
              >
                <template v-slot:leafNameDisplay="slotProps">
                  <span>
                    &nbsp;&nbsp;{{ slotProps.model.name }}
                  </span>
                </template>
                <template v-slot:treeNodeIcon>
                  <AppIcon name="folder" class="icon" />
                </template>
                <template v-slot:leafNodeIcon>
                  <AppIcon name="description" class="icon" />
                </template>
              </vue-tree-list>

              <EmptyState v-if="suppliers && !suppliers.length" icon="group" title="No se encontraron proveedores con listas de precios cargadas" />
            </div>
          </b-card>
        </b-col>
        <div v-if="!statusEditPrice && treeCollapsed" class="cost-tree-collapsed-bar" @click="treeCollapsed = false" v-b-tooltip.hover.right title="Mostrar proveedores">
          <AppIcon name="chevron_right" />
          <span class="cost-tree-collapsed-text">Proveedores</span>
        </div>
        <b-col :lg="statusEditPrice ? 12 : (treeCollapsed ? 12 : 9)" :class="{'cost-tree-products-expanded': treeCollapsed && !statusEditPrice}">
          <b-card>
            <b-row class="align-items-center">
              <b-col sm="8" class="d-flex align-items-center flex-wrap">
                <span class="crud-price-list-suppliers-download mr-2">
                  <b-link v-if="itemSelected" title="Descargar lista de precios en formato CSV para el proveedor seleccionado" @click="prepareExport()">
                    <AppIcon name="download" class="text-success" />
                  </b-link>
                </span>
                <b class="mr-2">{{this.itemSelected}}</b>
                <b-button v-if="!statusEditPrice && itemSelected && access.elements.changeProductsSale" variant="outline-secondary" size="sm" class="btn-pill mr-2" @click="initChangePrice()" v-b-tooltip.hover title="Edición múltiple de precios">
                  <AppIcon name="edit" class="mr-1" />
                  Edición múltiple
                </b-button>
                <small v-if="statusEditPrice" class="text-muted mr-2">
                  Click en una fila para editar listas de precios
                </small>
                <span v-if="statusEditPrice" class="ml-1">
                  <b-link href="javascript:void(0);" @click="endChangePrice()" title="Click para finalizar edición">
                    <b-badge variant="warning">
                      FINALIZAR MODO EDICIÓN DE PRECIOS MÚLTIPLE
                    </b-badge>
                  </b-link>
                </span>
              </b-col>
              <b-col sm="4" class="cpls-mode-indicators">
                <div class="cpls-iva-toggle"
                     :class="{ 'cpls-iva-toggle--active': priceWithIva }"
                     v-b-tooltip.hover.bottom
                     title="Ingresar y visualizar el precio de lista con IVA incluido">
                  <b-form-checkbox v-model="priceWithIva" @change="onPriceWithIvaToggle" switch>
                    <span class="font-weight-bold">Precios c/IVA</span>
                  </b-form-checkbox>
                </div>
                <div class="cpls-rounded-badge"
                     v-if="hasRoundPriceUp"
                     v-b-tooltip.hover.bottom
                     :title="parameters.roundingMultiple > 0 ? ('Redondeo activo · múltiplo de ' + parameters.roundingMultiple) : 'Redondeo activo · sin decimales'">
                  <AppIcon name="arrow_circle_up" class="mr-1" />Redondeado
                </div>
              </b-col>
            </b-row>

            <b-row v-if="!itemSelected && !statusEditPrice">
              <b-col sm="12" class="mt-3">
                <EmptyState icon="storefront"
                            title="Elegí un proveedor para empezar"
                            description="Seleccioná un proveedor en el panel de la izquierda para ver y editar sus productos." />
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col sm="12" class="mt-2">

                <b-table class="mb-0 app-table crud-price-list-suppliers-table"
                      :class="{'price-list-editor-table': statusEditPrice}"
                      style="min-height:250px;"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      sticky-header="60vh"
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="table.items"
                      :fields="table.fields"
                      :filter="table.filter"
                      :current-page="table.currentPage"
                      :per-page="table.perPage"
                      selectable
                      select-mode="single"
                      :busy="table.isBusy"
                      :tbody-tr-class="rowClass"
                      @row-clicked="onRowClicked"
                      v-if="(table.items && table.items.length) || table.isBusy">
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template> 

                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Cargando...</strong>
                    </div>
                  </template>

                  <template v-slot:cell(code)="data">
                    <span :title="data.item.code">
                      <AppIcon name="warning"
                               class="mr-2 text-warning"
                               title="Producto no importado"
                               v-if="data.item.not_imported" />
                      {{data.item.code}}
                    </span>
                  </template>

                  <template v-slot:cell(name)="data">
                    <span :id="'popover-name-' + data.item.id" style="cursor:pointer;">
                      {{data.item.name}}
                    </span>
                    <AppIcon name="error"
                             class="text-danger"
                             title="No tiene relación con ningún Producto de Venta"
                             v-if="!data.item.products_id" />

                    <b-popover custom-class="popover-name-cost-suplliers-products" :target="'popover-name-' + data.item.id" variant="warning" triggers="hover">                            
                      <div v-html="showParseReferenceExternal(data.item)"></div>
                    </b-popover>                         
                  </template>

                  <template v-slot:cell(category)="data">
                    <span :title="data.item.category + ' > ' + data.item.subcategory">
                      {{data.item.category}} > {{data.item.subcategory}}
                    </span>
                  </template>

                  <template v-slot:cell(unit_measurement)="data">   
                    <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                      {{ data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.reference }}
                    </div>
                  </template>

                  <template v-slot:cell(raise)="data">   
                    <div v-html="showRaisePrice(data.item)"></div>                      
                  </template>

                  <template v-slot:cell(price_list)="data">
                    <div>
                      <div v-if="statusEditPrice && data.item.default">
                        <b-input-group size="sm" class="crud-products-customers-other">
                          <b-input-group-prepend is-text>{{getCurrencySymbol}}</b-input-group-prepend>
                          <b-form-input v-if="priceWithIva"
                                        aria-label="Precio de Lista c/IVA"
                                        :title="getPriceListOppositeTitle(data.item, crud.prodTMP[data.index])"
                                        v-model="crud.prodTMP[data.index]['price_list_iva']"
                                        type="number" step="0.01" min="0"
                                        @focus="$event.target.select()"
                                        @blur="onPriceBlur(crud.prodTMP[data.index])"
                                        v-on:keyup.enter.native="savePrice(crud.prodTMP[data.index])">
                          </b-form-input>
                          <b-form-input v-else
                                        aria-label="Precio de Lista"
                                        :title="getPriceListOppositeTitle(data.item, crud.prodTMP[data.index])"
                                        v-model="crud.prodTMP[data.index]['price_list']"
                                        type="number" step="0.01" min="0"
                                        @focus="$event.target.select()"
                                        @blur="onPriceBlur(crud.prodTMP[data.index])"
                                        v-on:keyup.enter.native="savePrice(crud.prodTMP[data.index])">
                          </b-form-input>
                          <b-input-group-append>
                            <b-button variant="success" title="Guardar" tabindex="-1" @click="confirmSavePriceInline(crud.prodTMP[data.index])">
                              <AppIcon name="save" />
                            </b-button>
                            <b-button v-if="canUndoPrice(data.item)" variant="outline-warning" tabindex="-1" v-b-tooltip.hover :title="getUndoTitle(data.item)" @click="restorePriceInline(data.item, data.index)">
                              <AppIcon name="undo" />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                      <div v-else>
                        <b :title="getPriceListOppositeTitle(data.item)">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                            priceWithIva && getItemIvaAliquot(data.item) > 0
                              ? data.item.price_list * (1 + getItemIvaAliquot(data.item) / 100)
                              : data.item.price_list
                          )}}
                        </b>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(cost)="data">
                    <div>
                      <span v-if="data.item.price_list != data.item.price_cost">
                        <span :id="'popover-price-' + data.item.id" style="cursor:pointer;">
                          <b :title="getPriceCostOppositeTitle(data.item)">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                              priceWithIva && getItemIvaAliquot(data.item) > 0
                                ? data.item.price_cost * (1 + getItemIvaAliquot(data.item) / 100)
                                : data.item.price_cost
                            )}}
                          </b>
                        </span>
                        <b-popover custom-class="popover-price-cost-suplliers-products" :target="'popover-price-' + data.item.id" variant="warning" triggers="hover">
                          <div v-html="showParseExtras(data.item)"></div>
                        </b-popover>
                      </span>
                    </div>
                  </template>    

                  <template v-slot:cell(default)="data">
                    <div v-if="data.item.product.active">
                      <b-badge v-if="data.item.default" variant="dark">
                        SI
                      </b-badge>
                    </div>
                  </template>

                  <template v-slot:cell(last_update)="data">
                    <div v-if="data.item.product.active">
                      <span v-if="diffLastUpdate(data.item) <= 7" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                        <AppIcon name="circle-fill" class="text-success" />
                      </span>
                      <span v-if="diffLastUpdate(data.item) > 7 && diffLastUpdate(data.item) <= 15" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                        <AppIcon name="circle-fill" class="text-warning" />
                      </span>
                      <span v-if="diffLastUpdate(data.item) > 15 && diffLastUpdate(data.item) <= 30" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                        <AppIcon name="circle-fill" class="text-warning" />
                      </span>
                      <span v-if="diffLastUpdate(data.item) > 30" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                        <AppIcon name="circle-fill" class="text-danger" />
                      </span>
                    </div>
                  </template>     

                  <template v-slot:cell(prices)="data">    
                    <div v-if="data.item.product.active">                                    
                      <div v-if="data.item.product.prices.length > 0">
                        <div v-for="element in data.item.product.prices" :key="element.id">
                          <div v-if="element.list && element.list.id == showPriceSalesDefault" style="cursor:pointer;" @click="setPricesProducts(data.item)">
                            <span :id="'popover-price-sales-' + element.id">
                              <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}</b>
                              <span v-if="element.unit_measurement_result"> {{element.unit_measurement_result.reference}}</span>
                              <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                                <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                              </span>
                            </span>
                            <b-popover custom-class="popover-price-cost-suplliers-products" :target="'popover-price-sales-' + element.id" variant="secondary" triggers="hover">                            
                              <div v-html="showParsePriceSales(element)"></div>                      
                            </b-popover>                       
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>                                                 
                                
                  <template v-slot:cell(prices_iva)="data">
                    <div v-if="data.item.product.active">   
                      <div v-if="data.item.product.prices.length > 0">
                        <div v-for="element in data.item.product.prices" :key="element.id">
                          <div v-if="element.list && element.list.id == showPriceSalesDefault" style="cursor:pointer;" @click="setPricesProducts(data.item)">
                            <span :id="'popover-price-sales-iva-' + element.id">
                              <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total_iva)}}</b>
                              <span v-if="element.unit_measurement_result"> {{element.unit_measurement_result.reference}}</span>
                              <span v-if="parseFloat(element.desc) > 0" class="ml-1">
                                <i>({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(element.desc)/100)}})</i>
                              </span>
                            </span>

                            <b-popover custom-class="popover-price-cost-suplliers-products" :target="'popover-price-sales-iva-' + element.id" variant="secondary" triggers="hover">                            
                              <div v-html="showParsePriceIvaSales(element, data.item.product)"></div>
                            </b-popover> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right
                                no-caret
                                size="sm"
                                variant="link"
                                boundary="window"
                                :toggle-class="isMobileViewport ? 'cpls-action-toggle-labeled' : 'app-table-action-toggle'"
                                class="crud-price-list-suppliers-table-action"
                                :toggle-attrs="statusEditPrice ? { tabindex: -1 } : {}">
                      <template #button-content>
                        <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                        <span v-if="isMobileViewport">Opciones</span>
                      </template>

                      <b-dropdown-item v-if="data.item.product.active && data.item.reference_external" @click="sincroPrice(data.item)">
                        <AppIcon name="refresh" /> Sincronizar Precios
                      </b-dropdown-item>
                      <b-dropdown-divider v-if="data.item.product.active && data.item.reference_external"/>

                      <b-dropdown-item @click="showHistory(data.item)">
                        <AppIcon name="history" /> Historial
                      </b-dropdown-item>
                      <b-dropdown-item v-if="data.item.product.active && data.item.products_id" @click="showCompare(data.item)">
                        <AppIcon name="compare" /> Comparar Precios
                      </b-dropdown-item>
                      <b-dropdown-item v-if="!statusEditPrice && data.item.product && data.item.products_id" @click="openPriceListEditor(data.item)">
                        <AppIcon name="list-ul" /> Listas de Precios
                      </b-dropdown-item>

                      <b-dropdown-header v-if="data.item.product.active && access.elements.changeProductsSale">Acciones</b-dropdown-header>
                      <b-dropdown-item v-if="data.item.product.active && !data.item.default && access.elements.changeProductsSale" @click="setDefault(data.item)">
                        <AppIcon name="radio_button_checked" /> Marcar Por Default
                      </b-dropdown-item>
                      <b-dropdown-item v-if="data.item.product.active && data.item.default && access.elements.changeProductsSale" @click="editProduct(data.item)">
                        <AppIcon name="edit" /> Editar Producto
                      </b-dropdown-item>

                      <b-dropdown-divider v-if="access.elements.changeProductsSale" />
                      <b-dropdown-item @click="activateProduct(data.item)" v-if="access.elements.changeProductsSale && !data.item.product.active">
                        <AppIcon name="toggle-on" /> Activar Producto
                      </b-dropdown-item>
                      <b-dropdown-item @click="inactivateProduct(data.item)" v-if="access.elements.changeProductsSale && data.item.product.active">
                        <AppIcon name="toggle-off" /> Inactivar Producto
                      </b-dropdown-item>

                      <b-dropdown-divider v-if="access.elements.changeProductsSale" />
                      <b-dropdown-item @click="deleteProduct(data.item)" v-if="access.elements.changeProductsSale">
                        <AppIcon name="delete" class="text-danger" /> Eliminar Producto
                      </b-dropdown-item>

                      <b-dropdown-divider v-if="data.item.product.active && data.item.history.length"/>
                      <b-dropdown-item v-if="data.item.product.active && data.item.history.length" @click="undoPrice(data.item)">
                        <AppIcon name="undo" class="text-danger" /> Deshacer precio actual
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
                <EmptyState v-else
                            icon="reports"
                            title="No hay productos para mostrar"
                            description="Ajustá los filtros o el proveedor seleccionado para ampliar la búsqueda." />

                <div class="app-table-footer" v-if="table.tablePaginate">
                  <span class="list-view-toolbar__count">{{ table.tablePaginate.total }} registros</span>
                </div>
              </b-col>
              <b-col class="mt-4">
                <nav v-if="table.tablePaginate">
                  <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="table.tablePaginate.total"
                                :per-page="table.tablePaginate.per_page"
                                v-model="table.currentPage"
                                @input="selectedItem(filterQuery, true)" />
                </nav>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.push({ name: 'CostsStaffDashboard' })">
                <AppIcon name="back" class="mr-1" />Volver
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CONFIRMAR GUARDAR PRECIO -->
      <b-modal v-model="modal.confirmSavePrice.active"
               size="sm"
               centered>
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="save" /></span>
          <h5 class="app-modal-header__title">Confirmar guardado</h5>
        </div>
        <p class="mb-1">¿Confirma que desea guardar el precio?</p>
        <p v-if="modal.confirmSavePrice.item" class="font-weight-bold">
          <template v-if="priceWithIva">
            {{ getCurrencySymbol }} {{ modal.confirmSavePrice.item.price_list_iva }}
            <small class="text-muted font-weight-normal ml-1">(c/IVA)</small>
          </template>
          <template v-else>
            {{ getCurrencySymbol }} {{ modal.confirmSavePrice.item.price_list }}
          </template>
        </p>
        <div slot="modal-footer">
          <b-button variant="outline-secondary" size="sm" class="mr-1" @click="modal.confirmSavePrice.active = false">Cancelar</b-button>
          <b-button variant="dark" size="sm" @click="confirmSavePriceConfirmed()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD IMPORTACIONES -->
      <b-modal  v-model="modal.formImport.active"
                size="lg"
                :key="modal.formImport._id"
                :id="modal.formImport._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="file-earmark-spreadsheet" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formImport.title}}</h5>
        </div>

        <b-row>
          <b-col md="12" class="mb-2">
            <div class="app-alert app-alert--info">
              <span class="app-alert__icon"><AppIcon name="info" /></span>
              <div class="app-alert__content">
                <h4 class="alert-heading">Importación de Lista de Precio por Proveedor</h4>

                <div>
                  <AppIcon name="forward" /> El sistema importará todos los registros cargados en el archivo.
                </div>
                <div>
                  <AppIcon name="forward" /> Esta importación solo permite agregar <b>Productos de Proveedores</b>.
                </div>
                <div>
                  <AppIcon name="forward" /> El <b>código de producto ingresado</b>, se vinculará con el <b>Producto Existente</b>, sino crea un <b>Producto Nuevo</b>.
                </div>
                <div>
                  <AppIcon name="forward" /> Si el <b>producto inactivado</b> tiene una relación unica con un producto de venta, tambien lo <b>inactivará</b>.
                </div>
                <div>
                  <AppIcon name="forward" /> En caso que el <b>producto de venta</b> tenga varios proveedores, solo se <b>inactivará</b> el producto para ese proveedor
                </div>
                <div>
                  <AppIcon name="forward" /> Es posible cargar una <b>utilidad diferencial</b> por <b>producto</b> para una <b>lista de precios</b>.
                </div>

                <hr>

                <div class="mb-0">
                  Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/costs/csv-format-costs-suppliers-products.csv')"><b>formato de ejemplo</b></a> para esta importación.
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="12" class="mb-2">
            <FindObject type="suppliers"
                        @select-object="loadSuppliersImportCSV($event)"
                        :valueID="crud.formImport.suppliers_id"
                        :where="conditionSuppliersActive"
                        render="search"/>
          </b-col>
          <b-col md="12" class="mb-2">
            <b-form-group label="Archivo CSV [Lista de Precios]">
              <b-form-file v-model="crud.formImport.file"
                            size="sm"
                            :state="Boolean(crud.formImport.file)"
                            placeholder="Elija un archivo o sueltelo aquí..."
                            drop-placeholder="Suelta el archivo aquí...">
              </b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="12" class="mb-2">
            <b-form-group label="Tipo de Importación">
              <b-form-select v-model="crud.formImport.typeImport" :options="typeImportOptions" @input="changeTypeImportCSV()"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formImport.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="openImportEditorFromCSV()" :disabled="!crud.formImport.file"><AppIcon name="edit" class="mr-1" />Abrir en editor</b-button>
        </div>

      </b-modal>

      <!-- HISTORIAL -->
      <b-modal v-model="modal.formHistory.active"
               size="xl">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="history" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formHistory.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <b>{{this.itemSelectedHistory.toUpperCase()}}</b>
          </b-col>
          <b-col lg="12" class="cost-supplier-products-history-overflow">
            <b-table class="mb-0 app-table app-table--compact"
                  responsive
                  :stacked="isMobileViewport ? 'md' : false"
                  :hover="true"
                  :small="true"
                  :fixed="false"
                  :items="tableHistory.items"
                  :fields="tableHistory.fields"
                  :filter="tableHistory.filter"
                  :current-page="tableHistory.currentPage"
                  :per-page="tableHistory.perPage"
                  :busy="tableHistory.isBusy"                     
                  v-if="tableHistory.items.length || tableHistory.isBusy">   
                
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                {{moment(data.item.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(unit_measurement)="data">   
                <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                  {{ data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.reference }}
                </div>
              </template>

              <template v-slot:cell(price_list)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                    priceWithIva && tableHistory.ivaAliquot > 0
                      ? data.item.price_list * (1 + tableHistory.ivaAliquot / 100)
                      : data.item.price_list
                  )}}
                </b>
              </template>

              <template v-slot:cell(extra)="data">
                <span v-if="data.item.additional">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional)}}
                </span>
              </template>

              <template v-slot:cell(percentage_discount)="data">
                <span v-if="getDiscount(data.item,1)"> -{{getDiscount(data.item,1)}} </span>
                <span v-if="getDiscount(data.item,2)"> -{{getDiscount(data.item,2)}} </span>
                <span v-if="getDiscount(data.item,3)"> -{{getDiscount(data.item,3)}} </span>
                <span v-if="getDiscount(data.item,1) || getDiscount(data.item,2) || getDiscount(data.item,3)">%</span>
              </template>

              <template v-slot:cell(additional)="data">
                <span v-if="getAdditional(data.item,1)"> +{{getAdditional(data.item,1)}} </span>
                <span v-if="getAdditional(data.item,2)"> +{{getAdditional(data.item,2)}} </span>
                <span v-if="getAdditional(data.item,1) || getAdditional(data.item,2)">%</span>
              </template>

              <template v-slot:cell(extra_1)="data">
                <span v-if="data.item.additional_1">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional_1)}}
                </span>
              </template>

              <template v-slot:cell(cost)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                    priceWithIva && tableHistory.ivaAliquot > 0
                      ? data.item.price_cost * (1 + tableHistory.ivaAliquot / 100)
                      : data.item.price_cost
                  )}}
                </b>
              </template>
            </b-table>
            <EmptyState v-else icon="history" title="No se encontró el historial" />
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1 d-inline-flex align-items-center" @click="closeHistory()"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- CONVERSION -->
      <b-modal v-model="modal.formConvert.active"
               size="xl"
              :key="modal.formConvert._id"
              :id="modal.formConvert._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formConvert.title}}</h5>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark" nav-class="cpls-convert-tabs">
          <b-tab no-body>
            <template #title><AppIcon name="inventory_2" class="mr-1" /> General</template>
            <b-row>
              <b-col lg="12" v-if="this.itemSelectedConvert">
                <b>{{this.itemSelectedConvert.toUpperCase()}}</b>
              </b-col>
              <b-col lg="12">
                <b-form-radio-group
                  v-model="crud.formConvert.type"
                  :options="arr.typeConvert"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  @input="changeTypeConvert()"  
                  :disabled="!crud.formConvert.changeType"            
                ></b-form-radio-group>            
              </b-col>
              <b-col lg="12" v-if="!this.itemSelectedConvert">
                <FindObject type="suppliers" 
                            @select-object="loadSuppliersAddProduct($event)" 
                            tag="Proveedor"
                            :valueID="crud.formConvert.suppliers_id"
                            :where="conditionSuppliersActive"
                            render="search"/>  
              </b-col>              
              <b-col lg="12">
                <b-row>
                  <b-col lg="5">
                    <b-row>
                      <b-col lg="6" class="pr-0">
                        <b-form-group label="Cod Proveedor">
                          <b-form-input type="text"
                                        size="sm"
                                        lazy
                                        v-model="crud.formConvert.code"
                                        placeholder="Ingresar un código">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="6" class="pl-0">
                        <b-form-group label="Cod Propio">
                          <b-form-input type="text"
                                        size="sm"
                                        lazy
                                        v-model="crud.formConvert.code_system"
                                        placeholder="Ingresar un código">
                          </b-form-input>
                        </b-form-group>
                      </b-col>                      
                    </b-row>
                  </b-col>
                  <b-col lg="7" v-if="parameters.enableProductShortName">
                    <b-form-group label="Nombre Corto">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.name_short"
                                    placeholder="Ingresar un nombre corto">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col :lg="parameters.enableProductShortName ? 12 : 7">
                    <b-form-group :label="parameters.enableProductShortName ? 'Nombre Largo' : 'Nombre'">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.name"
                                    placeholder="Ingresar un nombre largo">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Categoría">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.category"
                                    placeholder="Ingresar una categoría">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Subcategoría">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.subcategory"
                                    placeholder="Ingresar una subcategoría">
                      </b-form-input>
                    </b-form-group>
                  </b-col>         
                  <b-col lg="6" v-if="hasLines">
                    <b-form-group label="Línea">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.line"
                                    placeholder="Ingresar una linea">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" v-if="hasLines">
                    <b-form-group label="Sublínea">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.subline"
                                    placeholder="Ingresar una subline">
                      </b-form-input>
                    </b-form-group>
                  </b-col>                           
                  <b-col lg="12">
                    <b-form-group label="Código de Barra">
                      <b-form-input type="text"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.barcode"
                                    placeholder="Ingresar un código de barra">
                      </b-form-input>
                    </b-form-group>          
                  </b-col>     
                  <b-col lg="12">
                    <hr>
                  </b-col>
                  <b-col lg="12">
                    <b-tabs pills card>
                      <b-tab no-body active>
                        <template #title><AppIcon name="edit" class="mr-1" /> Manual</template>
                        <b-form-group label="Referencia Externa" description="Es un código único del producto utilizado para actualizar precios desde intergaciones vía API">
                          <b-form-input type="text"
                                        size="sm"
                                        lazy
                                        v-model="crud.formConvert.reference_external"
                                        placeholder="Ingresar una referencia externa">
                          </b-form-input>
                        </b-form-group>
                      </b-tab>
                      <b-tab no-body>
                        <template #title><AppIcon name="search" class="mr-1" /> Base de datos</template>
                        <FindObject type="costsSuppliersProductsSupport"
                                    tag="Referencia Externa"
                                    description="Seleccione la referencia a un producto externo desde base de datos"
                                    @select-object="loadReferenceExternal($event)"
                                    display="reference"
                                    referenceSTR="reference"
                                    :valueSTR="crud.formConvert.reference_external"                                    
                                    render="search"/>
                      </b-tab>
                    </b-tabs>
                  </b-col>                                                                       
                </b-row>
              </b-col>            
            </b-row>
          </b-tab>
          <b-tab no-body>
            <template #title><AppIcon name="currency-dollar" class="mr-1" /> Precio</template>
            <b-row>
              <b-col lg="5">
                <b-form-group v-if="priceWithIva" :label="'Precio de Lista c/IVA ($)'">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                lazy
                                v-model="crud.formConvert.price_list_iva"
                                placeholder="Precio de Lista c/IVA">
                  </b-form-input>
                  <small class="text-muted">
                    s/IVA: {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(formConvertPriceListNoIva)}}
                  </small>
                </b-form-group>
                <b-form-group v-else :label="'Precio de Lista ($)'">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                lazy
                                v-model="crud.formConvert.price_list"
                                placeholder="Precio de Lista">
                  </b-form-input>
                  <small class="text-muted">
                    c/IVA: {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(formConvertPriceListWithIva)}}
                  </small>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab no-body>
            <template #title><AppIcon name="add" class="mr-1" /> + ($)</template>
            <b-row>
              <b-col lg="12">
                <b-form-group :label="'Adicional ($)'" description="Se calcula sobre el precio de lista">
                  <b-form-input type="number"
                                size="sm"
                                lazy
                                v-model="crud.formConvert.additional"
                                placeholder="Adicional">
                  </b-form-input>            
                </b-form-group>
              </b-col>  
            </b-row>            
          </b-tab>
          <b-tab no-body>
            <template #title><AppIcon name="sell" class="mr-1" /> - (%)</template>
            <b-row>
              <b-col lg="12">
                <b-row>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 1 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.percentage_discount"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 2 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.percentage_discount_1"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 3 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.percentage_discount_2"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>              
            </b-row>
          </b-tab>
          <b-tab no-body>
            <template #title><AppIcon name="percent" class="mr-1" /> + (%) + ($)</template>
            <b-row>
              <b-col lg="12">
                <b-row>                      
                  <b-col lg="6">
                    <b-form-group :label="'Adiccional 1 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.additional_percentage"
                                    placeholder="Adiccional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group :label="'Adiccional 2 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.additional_percentage_1"
                                    placeholder="Adiccional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>              
                  <b-col lg="12">
                    <b-form-group :label="'Adicional ($)'" description="Se calcula sobre el precio final [precio de lista + adiccional ($) - descuentos (%) + adiccional (%)]">
                      <b-form-input type="number"
                                    size="sm"
                                    lazy
                                    v-model="crud.formConvert.additional_1"
                                    placeholder="Adicional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>      
                </b-row>
              </b-col> 
            </b-row>
          </b-tab>  
          <b-tab no-body v-if="hasMeasurement">
            <template #title><AppIcon name="square_foot" class="mr-1" /> Atributos</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Profundidad" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                lazy
                                v-model="crud.formConvert.depth"
                                required
                                placeholder="Ingresar una profundidad">
                  </b-form-input>
                </b-form-group>
              </b-col>    
              <b-col md="12">
                <b-form-group label="Largo" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                lazy
                                v-model="crud.formConvert.long"
                                required
                                placeholder="Ingresar un largo">
                  </b-form-input>
                </b-form-group>
              </b-col>    
              <b-col md="12">
                <b-form-group label="Alto" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                lazy
                                v-model="crud.formConvert.height"
                                required
                                placeholder="Ingresar un alto">
                  </b-form-input>
                </b-form-group>
              </b-col> 
              <b-col md="12">
                <b-form-group label="Peso" description="Ingrese el peso en kg">
                  <b-form-input type="number"
                                size="sm"
                                lazy
                                v-model="crud.formConvert.weight"
                                required
                                placeholder="Ingresar un peso">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
            </b-row>
          </b-tab>                  
          <b-tab no-body>
            <template #title><AppIcon name="straighten" class="mr-1" /> U.Medidas</template>
            <b-row>
              <b-col lg="8">
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Compra"
                            @select-object="loadUnitMeasurementPurchase($event)" 
                            :valueID="crud.formConvert.unit_measurement_purchase_id"
                            render="search"/>                       
              </b-col>              
              <b-col lg="8">
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Venta"
                            @select-object="loadUnitMeasurementSale($event)" 
                            :valueID="crud.formConvert.unit_measurement_sale_id"
                            render="search"/>                       
              </b-col>
              <b-col lg="4" v-if="crud.formConvert.unit_measurement_purchase_id != crud.formConvert.unit_measurement_sale_id">
                <b-form-group label="Variable" description="Variable de Conversión">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                lazy
                                v-model="crud.formConvert.unit_measurement_sale_conversion"
                                placeholder="Ingrese un valor">
                  </b-form-input>            
                </b-form-group>
              </b-col>                  
            </b-row>
            <b-row>
              <b-col lg="12">
                <b-form-checkbox v-model="crud.formConvert.weighable" switch>
                  Producto pesable
                </b-form-checkbox>
                <small class="text-muted">Se pesa al preparar el pedido. Requiere conversión entre la unidad de venta y KG.</small>
              </b-col>
            </b-row>
          </b-tab>            
          <b-tab no-body v-if="isProcessSales">
            <template #title><AppIcon name="receipt_long" class="mr-1" /> Fiscal</template>
            <b-row>
              <b-col lg="12">
                <FindObject render="search"
                            type="erpIvaConditions" 
                            @select-object="loadIvaConditions($event)" 
                            :valueID="crud.formConvert.iva_condition_id"/>
              </b-col>              
            </b-row>            
          </b-tab>                       
          <b-tab no-body lazy>
            <template #title><AppIcon name="list-ul" class="mr-1" /> Listas de Precios</template>
            <b-row>
              <b-col lg="12" :key="convertPriceForceUpdateKey" class="cost-supplier-products-edit-overflow">
                <b-row v-for="element in arr.listPrices" :key="element.id">
                  <b-col lg="5">
                    <div class="mt-3">
                      <b>Lista:</b> {{element.name}} ({{element.reference}}) <br>
                      <b>Defecto:</b> {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits: 2}).format( getUtility(element) )}}
                    </div>
                  </b-col>
                  <b-col lg="7" v-if="crud.formConvert.lists[element.id]">
                    <b-row>
                      <b-col lg="4 text-center">                    
                        <b-form-group label="Agregar" :title="crud.formConvert.lists[element.id]['add'] == true ? 'Se encuentra dentro de la lista de precios':'NO está incluido en la lista de precios'">
                          <b-form-checkbox size="md" v-model="crud.formConvert.lists[element.id]['add']"></b-form-checkbox>                          
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group :label="'Utilidad'">
                          <b-form-input type="number"
                                        size="sm"
                                        lazy
                                        v-model="crud.formConvert.lists[element.id]['utility']"
                                        placeholder="Ingresar utilidad diferencial para esta lista">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="4">
                        <b-form-group :label="'Descuento'">
                          <b-form-input type="number"
                                        size="sm"
                                        lazy
                                        v-model="crud.formConvert.lists[element.id]['desc']"
                                        placeholder="Ingresar el descuento para esta lista">
                          </b-form-input>
                        </b-form-group>
                      </b-col>                  
                    </b-row>
                  </b-col>
                  <b-col lg="12">
                    <hr class="mt-0 mb-2">
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>                    

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formConvert.active=false">Cerrar</b-button>
          <b-button variant="dark" @click="saveProduct()"><AppIcon name="save" class="mr-1" />GUARDAR</b-button>
        </div>
      </b-modal>

      <!-- COMPARE PRICE -->
      <b-modal v-model="modal.formCompare.active"
               size="xl">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="compare" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formCompare.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <b>{{this.itemSelectedCompare.toUpperCase()}}</b>
          </b-col>
          <b-col lg="12">
            <b-table class="mb-0 app-table app-table--compact"
                  responsive
                  :stacked="isMobileViewport ? 'md' : false"
                  :hover="true"
                  :small="true"
                  :fixed="false"
                  :items="tableCompare.items"
                  :fields="tableCompare.fields"
                  :filter="tableCompare.filter"
                  :current-page="tableCompare.currentPage"
                  :per-page="tableCompare.perPage"
                  :busy="tableCompare.isBusy"                     
                  v-if="tableCompare.items.length || tableCompare.isBusy">   
                
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(supplier)="data">
                {{data.item.supplier.name}}
              </template>

              <template v-slot:cell(unit_measurement)="data">   
                <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                  {{ data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.reference }}
                </div>
              </template>

              <template v-slot:cell(price_list)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                    priceWithIva && tableCompare.ivaAliquot > 0
                      ? data.item.price_list * (1 + tableCompare.ivaAliquot / 100)
                      : data.item.price_list
                  )}}
                </b>
              </template>

              <template v-slot:cell(extra)="data">
                <span v-if="data.item.additional">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional)}}
                </span>
              </template>

              <template v-slot:cell(percentage_discount)="data">
                <span v-if="getDiscount(data.item,1)"> -{{getDiscount(data.item,1)}} </span>
                <span v-if="getDiscount(data.item,2)"> -{{getDiscount(data.item,2)}} </span>
                <span v-if="getDiscount(data.item,3)"> -{{getDiscount(data.item,3)}} </span>
                <span v-if="getDiscount(data.item,1) || getDiscount(data.item,2) || getDiscount(data.item,3)">%</span>
              </template>

              <template v-slot:cell(additional)="data">
                <span v-if="getAdditional(data.item,1)"> +{{getAdditional(data.item,1)}} </span>
                <span v-if="getAdditional(data.item,2)"> +{{getAdditional(data.item,2)}} </span>
                <span v-if="getAdditional(data.item,1) || getAdditional(data.item,2)">%</span>
              </template>

              <template v-slot:cell(extra_1)="data">
                <span v-if="data.item.additional_1">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional_1)}}
                </span>
              </template>

              <template v-slot:cell(cost)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(
                    priceWithIva && tableCompare.ivaAliquot > 0
                      ? data.item.price_cost * (1 + tableCompare.ivaAliquot / 100)
                      : data.item.price_cost
                  )}}
                </b>
              </template>

              <template v-slot:cell(default)="data">
                <b-badge v-if="data.item.default" variant="dark">
                  SI
                </b-badge>
              </template>

              <template v-slot:cell(last_update)="data">
                <span v-if="diffLastUpdate(data.item) <= 7" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <AppIcon name="circle-fill" class="text-success" />
                </span>
                <span v-if="diffLastUpdate(data.item) > 7 && diffLastUpdate(data.item) <= 15" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <AppIcon name="circle-fill" class="text-warning" />
                </span>
                <span v-if="diffLastUpdate(data.item) > 15 && diffLastUpdate(data.item) <= 30" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <AppIcon name="circle-fill" class="text-warning" />
                </span>
                <span v-if="diffLastUpdate(data.item) > 30" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <AppIcon name="circle-fill" class="text-danger" />
                </span>
              </template>
            </b-table>
            <EmptyState v-else icon="compare" title="No se encontró ningún producto" />
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1 d-inline-flex align-items-center" @click="closeCompare()"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- MODIFICACION PRECIOS LOTE -->
      <b-modal v-model="modal.formEditPriceLote.active">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="percent" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formEditPriceLote.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <div class="app-alert app-alert--info">
              <span class="app-alert__icon"><AppIcon name="info" /></span>
              <div class="app-alert__content">
                Esta modificación de PRECIOS afectará a todos los productos filtrados y que estan agrupados por <b>"{{this.itemSelected}}"</b>.
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <b-form-group :label="'Porcentaje Aumento (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"                              
                              step="0.01"
                              v-model="crud.formEditPriceLote.percentage"
                              placeholder="Porcentaje"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>                                        
        </b-row>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEditPriceLote()">Cerrar</b-button>
          <b-button variant="dark" @click="saveEditPriceLote()"><AppIcon name="save" class="mr-1" />ACTUALIZAR</b-button>
        </div>
      </b-modal>

      <!-- MODIFICACION DESCUENTO LOTE -->
      <b-modal v-model="modal.formEditDiscountLote.active"
               size="lg">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="sell" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formEditDiscountLote.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <div class="app-alert app-alert--info">
              <span class="app-alert__icon"><AppIcon name="info" /></span>
              <div class="app-alert__content">
                Esta modificación de DESCUENTOS afectará a todos los productos filtrados y que estan agrupados por <b>"{{this.itemSelected}}"</b>.
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <b-form-group :label="'Descuento 1 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"
                              v-model="crud.formEditDiscountLote.discount1"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="'Descuento 2 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"
                              v-model="crud.formEditDiscountLote.discount2"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="'Descuento 3 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"                              
                              v-model="crud.formEditDiscountLote.discount3"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>        
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEditDiscountLote()">Cerrar</b-button>
          <b-button variant="dark" @click="saveEditDiscountLote()"><AppIcon name="save" class="mr-1" />ACTUALIZAR</b-button>
        </div>
      </b-modal>
      
      <!-- CRUD PRECIOS -->
      <b-modal  v-model="modal.formPrice.active"
                size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="currency-dollar" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formPrice.title}}</h5>
        </div>

        <b-row>         
          <b-col md="12">
            <div class="crud-price-list-suppliers-products-title" v-if="itemSelectedPrice">
              <div class="crud-price-list-suppliers-products-title">
                <span v-if="itemSelectedPrice.code" class="crud-price-list-suppliers-products-code">
                  {{this.itemSelectedPrice.code}} 
                </span><br>
                {{this.itemSelectedPrice.name}}
              </div>
              <hr>
            </div>
          </b-col>
          <b-col md="12">
            <b-table class="mb-0 crud-products-table-prices app-table app-table--compact"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="tablePrices.items"
                    :fields="tablePrices.fields"                            
                    v-if="tablePrices.items && tablePrices.items.length">   

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 
              
              <template v-slot:cell(list)="data">
                <div v-if="data.item.list">
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-product-list-prices-public">
                    (Pública)
                  </span>
                </div>
              </template>                                                

              <template v-slot:cell(price_list)="data">       
                <div v-if="data.item.unit_measurement_initial.reference != data.item.unit_measurement_result.reference">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_initial, data.item.desc, data.item))}}                
                  <span v-if="data.item.unit_measurement_initial">{{data.item.unit_measurement_initial.reference}}</span>
                </div>
              </template>

              <template v-slot:cell(price_public)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount_total, data.item.desc, data.item))}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(desc)="data">       
                <div v-if="parseFloat(data.item.desc) > 0">
                  {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.desc)/100)}}
                </div>
              </template>

              <template v-slot:cell(price_desc)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>

              <template v-slot:cell(price_iva)="data">                
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total_iva)}}                
                <span v-if="data.item.unit_measurement_result">{{data.item.unit_measurement_result.reference}}</span>
              </template>              
            </b-table>
            <EmptyState v-else icon="currency-dollar" title="No se encontraron precios para este producto" />
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1 d-inline-flex align-items-center" @click="modal.formPrice.active=false"><AppIcon name="x" class="mr-1" />Salir</b-button>
        </div>
      </b-modal>

      <!-- PRECIOS VENTA POR DEFECTO -->
      <b-modal  v-model="modal.formPriceSaleDefault.active"
                size="sm">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="currency-dollar" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formPriceSaleDefault.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
                <FindObject render="search"
                            type="priceList"
                            @select-object="loadPriceList($event)"
                            :valueID="crud.formPriceSaleDefault.price_list_id"
                            :where="conditionPriceListActive"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" size="sm" @click="modal.formPriceSaleDefault.active=false">Salir</b-button>
          <b-button variant="dark" size="sm" @click="savePriceSalesDefault()"><AppIcon name="save" class="mr-1" />GUARDAR</b-button>
        </div>
      </b-modal>

      <b-modal v-model="snapshotOffline.active" size="md" hide-footer>
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="cloud_download" /></span>
          <h5 class="app-modal-header__title">Actualizar precios modo offline</h5>
        </div>
        <p>
          Este proceso genera una foto actualizada de todos los precios calculados (costo + utilidad) y los guarda para que estén disponibles en modo offline.
        </p>
        <p class="text-muted small">
          El proceso corre en segundo plano y puede tardar algunos minutos. Podés continuar trabajando mientras tanto.
        </p>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" class="mr-2" @click="snapshotOffline.active = false">Cancelar</b-button>
          <b-button variant="dark" :disabled="snapshotOffline.loading" @click="forceSnapshotOffline()">
            <b-spinner small v-if="snapshotOffline.loading" class="mr-1"></b-spinner>
            <AppIcon v-else name="cloud_download" class="mr-1" />
            {{ snapshotOffline.loading ? 'Iniciando...' : 'Confirmar' }}
          </b-button>
        </div>
      </b-modal>

      <!-- SIDEBAR LISTAS DE PRECIOS -->
      <b-sidebar
        id="sidebar-price-lists"
        v-model="priceListEditor.active"
        right
        shadow
        backdrop
        :no-close-on-backdrop="priceListEditor.dirty"
        :no-close-on-esc="priceListEditor.dirty"
        :no-header-close="priceListEditor.dirty"
        title="Listas de Precios"
        width="420px">
        <div v-if="priceListEditor.loading" class="text-center my-3">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-1">Cargando...</strong>
        </div>

        <div v-else class="price-list-editor-body">
          <div class="d-flex justify-content-between align-items-start mb-2 price-list-editor-header">
            <div class="price-list-editor-header-left">
              <div class="font-weight-bold">Producto</div>
              <div class="small text-muted price-list-editor-product">
                {{ priceListEditor.productLabel }}
              </div>
            </div>
            <div class="text-right price-list-editor-header-actions">
              <b-button
                size="sm"
                variant="outline-secondary"
                class="mr-1"
                :disabled="!canGoPrevProduct"
                @click="goPrevProduct()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button
                size="sm"
                variant="outline-secondary"
                :disabled="!canGoNextProduct"
                @click="goNextProduct()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <b-badge v-if="priceListEditor.dirty" variant="warning">Cambios sin guardar</b-badge>
            <b-button
              v-if="priceListEditor.dirty"
              size="sm"
              variant="outline-danger"
              @click="cancelPriceListChanges()">
              Cancelar cambios
            </b-button>
          </div>

          <EmptyState v-if="!priceListEditor.lists.length" icon="sell" title="No hay listas de precios para mostrar" />

          <b-list-group v-else>
            <b-list-group-item
              v-for="list in priceListEditor.lists"
              :key="list.id"
              class="price-list-editor-item">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <div class="font-weight-bold">{{ list.name }}</div>
                  <div class="small text-muted">
                    Utilidad lista: {{ formatPercent(list.default_utility) }}
                  </div>
                </div>
                <b-form-checkbox
                  switch
                  v-model="list.active"
                  :disabled="list.saving"
                  @change="togglePriceList(list)">
                  {{ list.active ? 'En lista' : 'Sin lista' }}
                </b-form-checkbox>
              </div>

              <b-row class="mt-2">
                <b-col cols="6">
                  <b-form-group label="Utilidad (%)" label-size="sm">
                    <b-form-input
                      size="sm"
                      type="number"
                      step="0.01"
                      min="0"
                      v-model.number="list.utility"
                      @focus="$event.target.select()"
                      @input="markListDirty(list)"
                      :disabled="!list.active || list.saving">
                    </b-form-input>
                    <small v-if="list.active && !list.utility" class="text-muted">
                      Usa utilidad default
                    </small>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Desc. (%)" label-size="sm">
                    <b-form-input
                      size="sm"
                      type="number"
                      step="0.01"
                      min="0"
                      v-model.number="list.desc"
                      @focus="$event.target.select()"
                      @input="markListDirty(list)"
                      :disabled="!list.active || list.saving">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

            </b-list-group-item>
          </b-list-group>

          <div class="d-flex justify-content-end mt-2" v-if="priceListEditor.dirty">
            <b-button
              size="sm"
              variant="success"
              :disabled="priceListEditor.lists.some(l => l.saving)"
              @click="saveAllPriceLists()">
              <AppIcon name="save" /> Guardar todo
            </b-button>
          </div>
        </div>
      </b-sidebar>
    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'   
  import FindObject from '@/components/inc/find/findObject'
  import moment from 'moment'      
  import Param from '@/config/parameters'  
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import Vue from 'vue'
  import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
  Vue.use(VueTreeList)

  export default {
    components: {
      FindObject,
      VueTreeList,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudPriceListSuppliers',
          elements: {
            changeProductsSale: true,
          }
        }, 
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),
          haveMeasurement: Helper.hasParametersAccess(Param.P10),
          enabledPriceSales: Helper.hasParametersAccess(Param.P60),
          advancedImportTypes: Helper.hasParametersAccess(Param.P68),
          roundPriceUp: Helper.hasParametersAccess(Param.P69),
          enableProductShortName: Helper.hasParametersAccess(Param.P76),
          roundingMultiple: 0,
        },        
        table : {
          items: [],
          fields: [],
          filter: null,
          tablePaginate: null,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
        },
        filtersOpen: false,
        tableHistory: {
          items: [],
          ivaAliquot: 0,
          fields: [],
          tablePaginate: true,
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        tableCompare: {
          items: [],
          ivaAliquot: 0,
          fields: [],
          tablePaginate: true,
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        tablePrices : {
          items: [],
          fields: [],
        },
        crud: {          
          formImport: {
            suppliers: null,
            suppliers_id: 0,
            typeImport: 'default',
            file: '',
          },
          formConvert: {
            id: 0,
            type: 'NUEVO',
            barcode: '',
            code: '',
            code_system: '',
            name: '',
            name_short: '',
            category: '',
            subcategory: '',
            line: '',
            subline: '',            
            products_id: 0,
            products: null,
            changeType: false,
            lists: [],
            price_list: 0,
            price_list_iva: 0,
            percentage_discount: 0,
            percentage_discount_1: 0,
            percentage_discount_2: 0,
            additional: 0,
            additional_1: 0,
            additional_percentage: 0,
            additional_percentage_1: 0,
            unit_measurement_purchase_id: 0,
            unit_measurement_purchase: null,
            unit_measurement_sale_id: 0,
            unit_measurement_sale: null,            
            unit_measurement_sale_conversion: 0,   
            suppliers_id: 0,       
            depth: 0,
            long: 0,
            height: 0,
            weight: 0,
            iva_condition: null,
            iva_condition_id: 0,
            weighable: false,
            reference_external: null,
          },
          formEditPriceLote: {
            percentage: 0,
            operations: '+',
            filterQuery: []
          },
          formEditDiscountLote: {
            discount1: 0,
            discount2: 0,
            discount3: 0,
            filterQuery: []
          },          
          formPriceSaleDefault: {
            price_list: null,
            price_list_id: 0,
          },
          prodTMP: [],
        },                      
        arr: {
          fiscalCondition: [],
          listProducts: [],
          listPrices: [],
          export: [],
          typeConvert: [
            { item: 'NUEVO', name: 'Nuevo Producto' },
            { item: 'EDITAR', name: 'Editar Producto' },
          ],          
          filters : {
            suppliers: [],            
          }, 
          select: {
            haveReferenceExternal: [
              {code:true, label: 'Con Referencia'},
              {code:false, label: 'Sin Referencia'},              
            ],
            linkedProduct:[
              {code:true, label: 'Vinculados'},
              {code:false, label: 'Sin Vincular'},              
            ],               
            lastUpdate:[
              {value: null, text: 'Rango de Actualización'},
              {
                label: "SEMAFORO",
                options: [
                  {value: '0-7', text: 'Últimos 7 días'},
                  {value: '7-15', text: 'Entre 7 y 15 días'},
                  {value: '15-30', text: 'Entre 15 y 30 días'},
                  {value: '30-9999', text: 'Mas de 30 días'},
                ]
              },{
                label: "OTRAS OPCIONES",
                options: [
                  {value: 'hoy', text: 'Modificaciones de HOY'},              
                  {value: 'hoy-no', text: 'HOY sin modificación'},                    
                ]
              }            
            ],  
            notImported:[
              {code:true, label: 'Importados'},
              {code:false, label: 'No Importados'},              
            ],                           
            typeImport:[
              {value:'default', text: 'Actualiza solo los productos importados'},
              {value:'warning', text: 'Marca los productos que no se importaron en la lista'},
              {value:'delete', text: 'Elimina los productos que no se importaron en la lista'},              
            ],                                       
          }                               
        },           
        filters: {
          suppliers: null,
        },  
        filterQuery: {
          suppliers_id: 0,
          category: '',
          subcategory: '',
          text: '',
          haveReferenceExternal: null,
          linkedProduct: null,
          lastUpdate: null,
          notImported: null,
          paginate: true,
          showPriceSale: false,
        }, 
        modal: {
          formImport: {
            active: false,
            title: ''
          },
          formHistory: {
            active: false,
            title: ''            
          },
          formConvert: {
            active: false,
            title: ''                        
          },
          formCompare: {
            active: false,
            title: ''
          },    
          formEditPriceLote: {
            active: false,
            title: ''
          },
          formEditDiscountLote: {
            active: false,
            title: ''            
          },
          formPrice: {
            active: false,
            title: ''
          },
          formPriceSaleDefault: {
            active: false,
            title: ''
          },
          confirmSavePrice: {
            active: false,
            item: null,
          }
        },
        priceListEditor: {
          active: false,
          loading: false,
          product: null,
          productLabel: '',
          lists: [],
          selectedId: 0,
          dirty: false,
        },
        convertPriceForceUpdateKey: 0,
        priceWithIva: false,
        itemSelected: '',
        itemSelectedHistory: '',
        itemSelectedConvert: '',
        itemSelectedCompare: '',
        suppliers: null,
        suppliersTree: new Tree([]),       
        statusEditPrice: false,
        itemSelectedPrice: null,
        treeCollapsed: false,
        snapshotOffline: { active: false, loading: false },
        isMobileViewport: false,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.changeProductsSale = Helper.hasAccessElement(this.access, 'change_products_sale')       
      /* Fin configuracion */
    },     
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.filtersOpen = Storage.getValue('filters_open_crud_price_list_suppliers') == 'true'

      this.loadPriceWithIvaPreference()
      this.restoreFilterStorage()
      this.loadFieldTable()
      this.loadFieldsHistory()
      this.loadFieldsCompare()
      this.loadFieldsPrices()

      this.loadSuppliers()
      this.filterLoad()
      this.loadListsPrices()
      this.loadFiscalCondition()

      if (this.hasRoundPriceUp) {
        serviceAPI.obtenerConfiguracion().then(response => {
          var cfg = response.data.find(e => e.id == 1)
          if (cfg) this.parameters.roundingMultiple = parseInt(cfg.value_number) || 0
        })
      }

      this._start = true
    },
    updated() {
      this.decorateSupplierTreeLabels()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.loadSuppliers()         
      this.filterLoad()      
      this.loadListsPrices()
      this.loadFiscalCondition()           
    },     
    computed: {
      getCurrency() {
        return 'ARS'
      },
      getCurrencySymbol() {
        return '$'
      },
      typeImportOptions() {
        if(this.parameters.advancedImportTypes) {
          return this.arr.select.typeImport
        }
        return this.arr.select.typeImport.filter(item => item.value === 'default')
      },

      // CONDITIONS SELECT
      conditionSuppliersActive(){
        return [
          {field: 'active', condition: true},
          {field: 'shipping', condition: false}
        ];
      },     
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },    
      
      // PRICE SALES DEFAULT
      showPriceSalesDefault() {        
        let priceID = 0
        if(this.hasShowPriceSales) {
          if(this.crud.formPriceSaleDefault.price_list_id) {
            priceID = this.crud.formPriceSaleDefault.price_list_id
          }
        }
        return priceID
      },
      
      // PARAMETROS
      hasLines() {
        return this.parameters.haveLines
      },
      hasMeasurement() {        
        return this.parameters.haveMeasurement
      },      
      isProcessSales() {
        var status = false
        var modulesActive = Session.getSession().auth.user.permissions.modules
        modulesActive.forEach(element => {
          if(element.id == Modules.VENTAS || element.id == Modules.PRESUPUESTOS) {
            status = true
          }
        })
        return status
      }, 
      hasShowPriceSales() {
        return this.parameters.enabledPriceSales
      },
      hasRoundPriceUp() {
        return this.parameters.roundPriceUp
      },

      formConvertPriceListNoIva() {
        var cond = this.arr.fiscalCondition.find(c => c.id === this.crud.formConvert.iva_condition_id)
        var iva = cond ? parseFloat(cond.aliquot || cond.percentage || 0) : 0
        var priceIva = parseFloat(this.crud.formConvert.price_list_iva) || 0
        return iva > 0 ? Math.round(priceIva / (1 + iva / 100) * 100) / 100 : priceIva
      },
      formConvertPriceListWithIva() {
        var cond = this.arr.fiscalCondition.find(c => c.id === this.crud.formConvert.iva_condition_id)
        var iva = cond ? parseFloat(cond.aliquot || cond.percentage || 0) : 0
        var price = parseFloat(this.crud.formConvert.price_list) || 0
        return Math.round(price * (1 + iva / 100) * 100) / 100
      },
      currentPriceListIndex() {
        if(!this.priceListEditor.selectedId || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.priceListEditor.selectedId)
      },
      canGoPrevProduct() {
        return this.currentPriceListIndex > 0
      },
      canGoNextProduct() {
        if(this.currentPriceListIndex < 0) {
          return false
        }
        return this.currentPriceListIndex < (this.table.items.length - 1)
      },
      hasProductsToFilter() {
        // Los filtros deben permanecer disponibles aunque la consulta actual no
        // devuelva filas; de otro modo no se pueden corregir ni limpiar.
        return !!this.itemSelected
      },
    },
    watch: {
      'priceListEditor.active'(value) {
        if(!value) {
          this.priceListEditor.selectedId = 0
          this.priceListEditor.dirty = false
        }
      },
      filtersOpen(value) {
        Storage.setValue('filters_open_crud_price_list_suppliers', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
        this.loadFieldsHistory()
        this.loadFieldsCompare()
        this.loadFieldsPrices()
      }
    },
    methods: {
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      applyProductFilters() {
        if(!this.itemSelected) {
          this.$awn.info("Seleccioná un proveedor para poder filtrar sus productos")
          return
        }
        this.selectedItem(this.filterQuery, true)
      },

      // CONFIGURACION
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      loadFieldTable () {
        this.table.fields = []

        if(this.showPriceSalesDefault) {
          this.table.fields.push({key: 'code', label: 'Código', class:this.alignClass('text-left') + ' align-middle text-truncate', width:"35px"});
          this.table.fields.push({key: 'name', label: 'Nombre', class:this.alignClass('text-left') + ' align-middle text-truncate', width:"130px"});
          this.table.fields.push({key: 'raise', label: this.isMobileViewport ? 'Variación' : '', class:this.alignClass('text-right') + ' align-middle text-truncate', width:"20px"});
          this.table.fields.push({key: 'unit_measurement', label: 'U.Med.', class:this.alignClass('text-center') + ' align-middle text-truncate', width:"20px"});
          this.table.fields.push({key: 'price_list', label: 'P.Lista', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'cost', label: 'P.Compra', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'prices', label: 'P.Venta', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'prices_iva', label: 'P.Venta + IVA', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'last_update', label: this.isMobileViewport ? 'Última Actualización' : '', class:this.alignClass('text-center') + ' align-middle', width:"20px"});
          this.table.fields.push({key: 'default', label: 'Default', class:this.alignClass('text-center') + ' align-middle', width:"20px"});
          this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:this.alignClass('text-right') + ' align-middle', width:"10px"});
        } else {
          this.table.fields.push({key: 'code', label: 'Código', class:this.alignClass('text-left') + ' align-middle text-truncate', width:"35px"});
          this.table.fields.push({key: 'name', label: 'Nombre', class:this.alignClass('text-left') + ' align-middle text-truncate', width:"130px"});
          this.table.fields.push({key: 'raise', label: this.isMobileViewport ? 'Variación' : '', class:this.alignClass('text-right') + ' align-middle text-truncate', width:"20px"});
          this.table.fields.push({key: 'unit_measurement', label: 'U.Med.', class:this.alignClass('text-center') + ' align-middle text-truncate', width:"20px"});
          this.table.fields.push({key: 'price_list', label: 'P.Lista', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'cost', label: 'P.Compra', class:this.alignClass('text-right') + ' align-middle', width:"100px"});
          this.table.fields.push({key: 'last_update', label: this.isMobileViewport ? 'Última Actualización' : '', class:this.alignClass('text-center') + ' align-middle', width:"20px"});
          this.table.fields.push({key: 'default', label: 'Default', class:this.alignClass('text-center') + ' align-middle', width:"20px"});
          this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:this.alignClass('text-right') + ' align-middle', width:"10px"});
        }
      },
      loadFieldsHistory() {
        this.tableHistory.fields = [
          {key: 'date', label: 'Fecha', class: this.alignClass('text-left') + ' align-middle', width:"30px"},
          {key: 'unit_measurement', label: 'U.Med.', class: this.alignClass('text-center') + ' align-middle text-truncate', width:"20px"},
          {key: 'price_list', label: 'Lista', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'extra', label: '+ ($)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'percentage_discount', label: '- (%)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'additional', label: '+ (%)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'extra_1', label: '+ ($)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'cost', label: 'Compra', class: this.alignClass('text-right') + ' align-middle', width:"100px"},
        ]
      },
      loadFieldsCompare() {
        this.tableCompare.fields = [
          {key: 'supplier', label: 'Proveedor', class: this.alignClass('text-left') + ' align-middle text-truncate', width:"120px"},
          {key: 'unit_measurement', label: 'U.Med.', class: this.alignClass('text-center') + ' align-middle text-truncate', width:"20px"},
          {key: 'price_list', label: 'Lista', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'extra', label: '+ ($)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'percentage_discount', label: '- (%)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'additional', label: '+ (%)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'extra_1', label: '+ ($)', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'cost', label: 'Compra', class: this.alignClass('text-right') + ' align-middle', width:"80px"},
          {key: 'last_update', label: this.isMobileViewport ? 'Última Actualización' : '', class: this.alignClass('text-center') + ' align-middle', width:"20px"},
          {key: 'default', label: 'Default', class: this.alignClass('text-center') + ' align-middle', width:"20px"},
        ]
      },
      loadFieldsPrices() {
        this.tablePrices.fields = [
          {key: 'list', label: 'Lista', class: this.alignClass('text-left') + ' align-middle', width:"25%"},
          {key: 'price_list', label: this.isMobileViewport ? 'Equivalencia' : '', class: this.alignClass('text-right') + ' align-middle', width:"15%"},
          {key: 'price_public', label: 'Precio', class: this.alignClass('text-right') + ' align-middle', width:"15%"},
          {key: 'desc', label: 'Descuento', class: this.alignClass('text-right') + ' align-middle', width:"15%"},
          {key: 'price_desc', label: 'Precio S/IVA', class: this.alignClass('text-right') + ' align-middle', width:"15%"},
          {key: 'price_iva', label: 'Precio C/IVA', class: this.alignClass('text-right') + ' align-middle', width:"15%"},
        ]
      },
      rowClass(item, type) {
        if(type !== 'row' || !item) {
          return ''
        }
        if(item.id === this.priceListEditor.selectedId) {
          return 'app-table-row-active'
        }
        return ''
      },
      onRowClicked(item, index, event) {
        if(!item || !item.product || !item.products_id) {
          return
        }
        if(event && event.target) {
          const ignoreTags = ['INPUT','BUTTON','A','SELECT','TEXTAREA','LABEL','SVG','PATH']
          if(ignoreTags.includes(event.target.tagName)) {
            return
          }
          if(event.target.closest('.crud-price-list-suppliers-table-action')) {
            return
          }
        }

        this.openPriceListEditor(item)
      },

      // IMPORT BY CSV
      getImportEditorPriceListsMeta() {
        if(!this.arr.listPrices || !this.arr.listPrices.length) {
          return []
        }

        return this.arr.listPrices
          .filter(list => list && list.reference)
          .map(list => ({
            id: list.id,
            name: list.name,
            reference: list.reference,
            utility: this.normalizeNumber(list.utility),
            currency: list.currency ? list.currency.code : 'ARS',
          }))
      },
      forceSnapshotOffline() {
        this.snapshotOffline.loading = true
        serviceAPI.forzarSnapshotPrecios()
          .then(response => {
            this.snapshotOffline.active = false
            this.$awn.success(response.data.message || 'El snapshot de precios se inició en segundo plano.')
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
          .finally(() => {
            this.snapshotOffline.loading = false
          })
      },

      openImportCSV() {
        this.crud.formImport.file = ''        
        this.crud.formImport.typeImport = 'default'
        this.crud.formImport.suppliers_id= (this.filterQuery['suppliers_id'] != undefined) ? this.filterQuery['suppliers_id'] : 0
        this.crud.formImport.suppliers= null
            
        this.modal.formImport._id = Math.random().toString(36).slice(2, 8)
        this.modal.formImport.title = "Gestor de Importaciones"
        this.modal.formImport.active = true
      },
      openImportEditorCreate() {
        const supplierId = (this.filterQuery['suppliers_id'] != undefined) ? this.filterQuery['suppliers_id'] : 0

        const baseColumns = [
          'id','code','name','name_short','category','subcategory','line','subline','depth','long','height','weight',
          'unit_measurement_purchase','unit_measurement_sale','unit_measurement_sale_conversion',
          'iva_condition','code_system','barcode','reference_external','default','price_list','additional',
          'percentage_discount','percentage_discount_1','percentage_discount_2','additional_percentage',
          'additional_percentage_1','additional_1'
        ]
        const references = new Set()
        if(this.arr.listPrices && this.arr.listPrices.length) {
          this.arr.listPrices.forEach(list => {
            if(list && list.reference) {
              references.add(list.reference)
            }
          })
        }
        const columns = [...baseColumns]
        references.forEach(ref => {
          const includeKey = 'include_' + ref
          const utilKey = 'utility_' + ref
          const descKey = 'desc_' + ref
          if(!columns.includes(includeKey)) columns.push(includeKey)
          if(!columns.includes(utilKey)) columns.push(utilKey)
          if(!columns.includes(descKey)) columns.push(descKey)
        })

        const payload = {
          columns: columns,
          data: [],
          suppliers_id: supplierId,
          suppliers_label: this.itemSelected || '',
          price_lists: this.getImportEditorPriceListsMeta(),
          category: this.filterQuery.category || '',
          subcategory: this.filterQuery.subcategory || '',
          typeImport: 'default',
          mode: 'create',
          importSessionId: Date.now() + '-' + Math.random().toString(36).slice(2)
        }
        Storage.setValue('costs_price_list_widget', JSON.stringify({
          suppliers_id: payload.suppliers_id,
          suppliers_label: payload.suppliers_label,
          category: payload.category,
          subcategory: payload.subcategory,
        }))
        Storage.setValue('costs_import_editor_payload', JSON.stringify(payload))
        this.$router.push({ name: 'CostsStaffPriceListSuppliersImportEditor' })
      },
      openImportEditorFromCSV() {
        const input = Array.isArray(this.crud.formImport.file) ? this.crud.formImport.file[0] : this.crud.formImport.file
        if(!input) {
          this.$awn.warning("Seleccione un archivo para continuar.");
          return
        }
        const supplierId = this.crud.formImport.suppliers_id || 0

        const readText = () => {
          if(typeof input.text === 'function') {
            return input.text()
          }
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = (event) => resolve((event && event.target && event.target.result) ? event.target.result : '')
            reader.onerror = () => reject(new Error('No se pudo leer el archivo'))
            reader.readAsText(input)
          })
        }

        let loader = this.$loading.show()
        readText()
          .then(text => {
            const content = (text || '').replace(/^\uFEFF/, '')
            const lines = content.split(/\r\n|\n|\r/).filter(line => line.trim() !== '')
            if(lines.length <= 1) {
              loader.hide()
              this.$awn.warning("El archivo no tiene datos para procesar.");
              return
            }
            const header = lines[0].split(';').map(col => col.trim())
            const columns = header.filter(col => col)
            const required = [
              'id','code','name','name_short','category','subcategory','line','subline','depth','long','height','weight',
              'unit_measurement_purchase','unit_measurement_sale','unit_measurement_sale_conversion',
              'iva_condition','code_system','barcode','reference_external','default','price_list','additional',
              'percentage_discount','percentage_discount_1','percentage_discount_2','additional_percentage',
              'additional_percentage_1','additional_1'
            ]
            const missing = required.filter(col => !columns.includes(col))
            const invalidOrder = required.some((col, idx) => columns[idx] !== col)
            if(missing.length || invalidOrder) {
              loader.hide()
              let message = 'Formato inválido. El archivo debe comenzar con las columnas: ' + required.join(', ') + '.'
              if(missing.length) {
                message += ' Faltan: ' + missing.join(', ') + '.'
              } else if(invalidOrder) {
                message += ' El orden de las primeras columnas es incorrecto.'
              }
              this.$awn.warning(message)
              return
            }
            const data = []
            for(let i = 1; i < lines.length; i += 1) {
              const rowValues = lines[i].split(';')
              const row = {}
              columns.forEach((col, idx) => {
                row[col] = (rowValues[idx] !== undefined) ? rowValues[idx] : ''
              })
              row._rowId = i
              data.push(row)
            }
            const supplierLabel = this.crud.formImport.suppliers
              ? this.crud.formImport.suppliers.name
              : (this.itemSelected || '')
            const payload = {
              columns,
              data,
              suppliers_id: supplierId,
              suppliers_label: supplierLabel,
              price_lists: this.getImportEditorPriceListsMeta(),
              category: this.filterQuery.category || '',
              subcategory: this.filterQuery.subcategory || '',
              typeImport: this.crud.formImport.typeImport || 'default',
              mode: 'edit',
              importSessionId: Date.now() + '-' + Math.random().toString(36).slice(2)
            }
            Storage.setValue('costs_price_list_widget', JSON.stringify({
              suppliers_id: payload.suppliers_id,
              suppliers_label: payload.suppliers_label,
              category: payload.category,
              subcategory: payload.subcategory,
            }))
            Storage.setValue('costs_import_editor_payload', JSON.stringify(payload))
            this.modal.formImport.active = false
            loader.hide()
            this.$router.push({ name: 'CostsStaffPriceListSuppliersImportEditor' })
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error));
          })
      },
      goDownloadFormat(value) {
        var win = window.open(Helper.getPathPublic(value), '_blank');        
        win.focus();
      },
      loadSuppliersImportCSV(object) {
        if(object){
          this.crud.formImport.suppliers = object
          this.crud.formImport.suppliers_id = object.id
        } else {
          this.crud.formImport.suppliers = null
          this.crud.formImport.suppliers_id = 0
        }
      },
      changeTypeImportCSV() {
        if(!this.parameters.advancedImportTypes && this.crud.formImport.typeImport !== 'default') {
          this.crud.formImport.typeImport = 'default'
          return
        }
        if(this.crud.formImport.typeImport == 'warning'){          
          this.$bvModal.msgBoxOk('Se marcarán todos los productos que no se agregaron al archivo. Se verificará en toda la lista del proveedor seleccionado', {
            title: 'ATENCIÓN!!! Importación de Productos por Proveedor',
            size: 'md',
            buttonSize: 'sm',            
            okVariant: 'warning',            
            headerBgVariant: 'warning',
            bodyBgVariant: 'light',
            footerBgVariant: 'light',            
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })
        } 
        
        if(this.crud.formImport.typeImport == 'delete'){          
          this.$bvModal.msgBoxOk('Se eliminarán todos los productos que no se agregaron al archivo. Se verificará en toda la lista del proveedor seleccionado', {
            title: 'ATENCIÓN!!! Importación de Productos por Proveedor',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerBgVariant: 'danger',
            bodyBgVariant: 'light',
            footerBgVariant: 'light',            
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })          
        }
      },

      // FILTER
      filterLoad() {   
        this.filterLoadSuppliers()          
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedoresOnlyImport()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.suppliers = []
          data.forEach(element => {   
            if(element.active && !element.shipping) {
              this.arr.filters.suppliers.push({ code: element.id, label: element.name })            
            }
          });          
          
          this.loadFilterByWidget()        
        })   
      },      

      // TREE
      loadSuppliers() {
        let loader = this.$loading.show()   
   
        var result = serviceAPI.obtenerProveedoresForTree(this.filters)
        result.then((response) => {
          loader.hide()
          
          this.arr.listProducts = [];
          this.suppliers = [];  
          this.suppliersTree = new Tree(this.suppliers);  

          var data = response.data                 
          if(Object.entries(data).length) {
            var arrSuppliers = []
            Object.entries(data).forEach(([key, element]) => {            
              arrSuppliers.push({
                id: element.id,
                name: element.name,
                category: element.category,
                subcategory: element.subcategory,
                products_count: element.products_count || 0,
              })
            });
            
            arrSuppliers = arrSuppliers.sort((a, b) => {
              return this.getTreeDisplayName(a.name).localeCompare(this.getTreeDisplayName(b.name), 'es', { sensitivity: 'base' })
            })
            
            const groupedSuppliers = []
            const seenSuppliers = new Set()
            arrSuppliers.forEach(element => {
              if(seenSuppliers.has(element.id)) return
              seenSuppliers.add(element.id)
              groupedSuppliers.push({
                id: element.id,
                name: element.name,
                rawName: element.name,
                products_count: element.products_count || 0,
                children: [],
              })
            })

            this.configTree(groupedSuppliers, arrSuppliers)
          }           
        })
        .catch(error => {         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });         
      },      
      configTree(group, data) {               
        this.suppliers = []
        group = (group || []).slice().sort((a, b) => {
          return this.getTreeDisplayName(a && (a.rawName || a.name)).localeCompare(
            this.getTreeDisplayName(b && (b.rawName || b.name)),
            'es',
            { sensitivity: 'base' }
          )
        })

        group.forEach((element, index) => {                                
          this.suppliers.push({            
            id: element.id,                  
            name: this.getSupplierTreeLabel(element.name, element.products_count),
            rawName: element.rawName || element.name,
            productsCountLabel: parseInt(element.products_count) || 0,
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,                     
            children: this.getChildrenCat(element.id, data),
          })       
        })                  

        this.suppliersTree = new Tree(this.suppliers)                
      },
      getChildrenCat(supplier_id, data) {                
        var arrChildrenCat = []
        if(data) {        
          var catSupplier = []
          data.forEach((element, index) => {   
            if(element.id == supplier_id) {
              catSupplier.push(element)
            }
          });
          var arrCat = Funciones.groupBy(catSupplier, (item)=>{return item.category})          
          arrCat = arrCat.sort((a, b) => {
            const aName = a && a[0] && a[0].category ? a[0].category : ''
            const bName = b && b[0] && b[0].category ? b[0].category : ''
            return this.getTreeDisplayName(aName).localeCompare(this.getTreeDisplayName(bName), 'es', { sensitivity: 'base' })
          })

          arrCat.forEach((element, index) => {                         
            arrChildrenCat.push({                   
              id: element[0].category,      
              name: element[0].category,                
              dragDisabled: true,
              addTreeNodeDisabled: true,
              addLeafNodeDisabled: true,
              editNodeDisabled: true,
              delNodeDisabled: true,                  
              isLeaf: false,      
              children: this.getChildrenSubcat(element),                      
            })            
          });     
        }         
        return arrChildrenCat
      },
      getChildrenSubcat(data) {                                       
        var arrChildrenSubcat = []
        if(data) {        
          data = data.slice().sort((a, b) => {
            return this.getTreeDisplayName(a.subcategory).localeCompare(this.getTreeDisplayName(b.subcategory), 'es', { sensitivity: 'base' })
          })
          data.forEach((element, index) => {                             
            arrChildrenSubcat.push({    
              id: element.subcategory,      
              name: element.subcategory,                
              dragDisabled: true,
              addTreeNodeDisabled: true,
              addLeafNodeDisabled: true,
              editNodeDisabled: true,
              delNodeDisabled: true,                  
              isLeaf: true,                            
            })                
          });     
        } 
        return arrChildrenSubcat  
      },
      getTreeDisplayName(value) {
        return (value || '').toString().trim()
      },
      getSupplierTreeLabel(name, productsCount) {
        const count = parseInt(productsCount) || 0
        return this.getTreeDisplayName(name) + ' (' + count + ')'
      },
      decorateSupplierTreeLabels() {
        if(!this.$el || !this.suppliers || !this.suppliers.length) return

        const treeRoot = this.$el.querySelector('#cost-tree-suppliers')
        if(!treeRoot) return

        const contentNodes = treeRoot.querySelectorAll('.vtl-node-content')
        if(!contentNodes || !contentNodes.length) return

        contentNodes.forEach((node) => {
          if(!node) return
          const text = (node.textContent || '').replace(/\s+/g, ' ').trim()
          if(!text) return

          const supplier = this.suppliers.find(item => text === this.getSupplierTreeLabel(item.rawName || item.name, item.productsCountLabel))
          if(!supplier) return

          const safeName = this.escapeHtml(supplier.rawName || supplier.name)
          const safeCount = this.escapeHtml(String(supplier.productsCountLabel))
          const expectedHtml = '<span class="supplier-tree-name">' + safeName + '</span> <span class="supplier-tree-count">(' + safeCount + ')</span>'
          if(node.innerHTML === expectedHtml) return
          node.innerHTML = expectedHtml
        })
      },
      escapeHtml(value) {
        return (value || '')
          .toString()
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      },
      getTreeRawName(node) {
        if(node && node.rawName) {
          return node.rawName
        }
        return this.getTreeDisplayName(node && node.name ? node.name : '')
      },
      selectedItem(params, forceSelected=false, forceBusy=true, msjDefault = '') {
        // Mientras hay una consulta de productos en curso, el árbol de proveedores queda
        // bloqueado visualmente (ver .cost-tree-suppliers-tree--loading). Este guard es el
        // respaldo en JS por si un click llega igual (doble click, touch) antes de que se
        // aplique el bloqueo visual: se ignora en vez de encolar otra consulta pesada.
        if(!forceSelected && this.table.isBusy) {
          return
        }

        this.table.isBusy = forceBusy

        if(!forceSelected) {
          let filterQuery = null
          if(params.parent.id) {
            if(params.isLeaf) {              
              filterQuery = {
                suppliers_id: params.parent.parent.id,
                category: params.parent.name,
                subcategory: params.name
              }              
              this.itemSelected = this.getTreeRawName(params.parent.parent).toUpperCase() + ' > ' + params.parent.name.toUpperCase() + ' > ' + params.name.toUpperCase()

            } else {              
              filterQuery = {
                suppliers_id: params.parent.id,
                category: params.name,
                subcategory: '',
              }              
              this.itemSelected = this.getTreeRawName(params.parent).toUpperCase() + ' > ' + params.name.toUpperCase()
            }
            
          } else {
            filterQuery = {
              suppliers_id: params.id,          
                category: '',
                subcategory: '',              
            }

            this.itemSelected = this.getTreeRawName(params).toUpperCase()
          }   

          this.filterQuery = Object.assign({}, this.filterQuery, filterQuery);          
        }
                
        this.filterQuery.showPriceSale = this.showPriceSalesDefault
        this.filterQuery.paginate = true

        var result = serviceAPI.obtenerProductsByFilter(this.filterQuery, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data       
          this.table.tablePaginate = data      
          this.table.items = data.data

          if(this.table.items) {
            this.table.items.forEach((element, index) => {
              if(!this.crud.prodTMP[index])
                this.crud.prodTMP[index] = []
              
              var _pl = element.price_list ? element.price_list : 0
              var _iva = this.getItemIvaAliquot(element)
              var _plIva = Math.round(_pl * (1 + _iva / 100) * 100) / 100
              this.crud.prodTMP[index] = {
                id: element.id,
                product_id: element.products_id,
                price_list: _pl,
                price_list_original: _pl,
                price_list_iva: _plIva,
                price_list_iva_original: _plIva,
              }

              element._cellVariants = {
                ...element._cellVariants, 
                price_list: 'secondary',                
              };
              if(element.price_list != element.price_cost) {
                element._cellVariants = {
                  ...element._cellVariants, 
                  price_list: 'secondary',
                  cost: 'secondary',                
                };
              }

              if(this.showPriceSalesDefault) {
                element.product.prices.forEach(_element => {                
                  if(_element && (_element.list.id == this.showPriceSalesDefault)) {
                    element._cellVariants = { 
                      ...element._cellVariants, 
                      prices: 'primary',
                      prices_iva: 'primary'
                    }                  
                  }                
                });                           
              }
                           
              if(moment(element.last_update_price).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {                
                element._cellVariants = { 
                  ...element._cellVariants, 
                  code: 'success',
                  name: 'success',
                  unit_measurement: 'success',
                  raise: 'success',
                }                                  
              }

              if(!element.product.active) {
                element._cellVariants = { 
                  ...element._cellVariants, 
                  code: 'danger',
                  name: 'danger',
                  unit_measurement: 'danger',
                  raise: 'danger',
                  price_list: 'danger',
                  cost: 'danger',
                  prices: 'danger',
                  prices_iva: 'danger',
                  last_update: 'danger',
                  default: 'danger',
                }                                  
              }
            })
          }
          
          this.table.isBusy = false

          if(msjDefault)
            this.$awn.info(msjDefault)          
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        })
      },
      prepareExport() {
        this.confirmDialog('¿Descargar lista de precios de los productos del proveedor seleccionado?', {
          title: 'Descargar lista de precios',
          icon: 'download',
          okTitle: 'GENERAR',
        })
        .then(value => {
          if (value) {
            this.$awn.info("Estamos procesando el archivo, por favor espere...");
            let loader = this.$loading.show();

            var result = serviceAPI.exportForCSV(this.filterQuery)
            result.then((response) => {
              var data = response.data

              if(data.length) {
                loader.hide()

                this.$awn.success("Finalizamos el proceso, abriendo editor...");
                let columns = Object.keys(data[0] || {})
                let payload = {
                  columns: columns,
                  data: data,
                  suppliers_id: this.filterQuery.suppliers_id || 0,
                  suppliers_label: this.itemSelected || '',
                  price_lists: this.getImportEditorPriceListsMeta(),
                  category: this.filterQuery.category || '',
                  subcategory: this.filterQuery.subcategory || '',
                  typeImport: (this.crud.formImport && this.crud.formImport.typeImport) ? this.crud.formImport.typeImport : 'default',
                  importSessionId: Date.now() + '-' + Math.random().toString(36).slice(2),
                }
                Storage.setValue('costs_price_list_widget', JSON.stringify({
                  suppliers_id: payload.suppliers_id,
                  suppliers_label: payload.suppliers_label,
                  category: payload.category,
                  subcategory: payload.subcategory,
                }))
                Storage.setValue('costs_import_editor_payload', JSON.stringify(payload))
                this.$router.push({ name: 'CostsStaffPriceListSuppliersImportEditor' })
              } else {
                loader.hide()
                this.$awn.warning("No se encontraron productos para exportar");
              }
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // TABLA
      getRowCount (items) {
        return items.length
      },      
      getDiscount(item, nivel=1) {
        if(nivel==1) {
          return parseFloat(item.percentage_discount)
        }        
        if(nivel==2) {
          return parseFloat(item.percentage_discount_1)
        }        
        if(nivel==3) {
          return parseFloat(item.percentage_discount_2)
        }                        
      },
      getAdditional(item, nivel=1) {
        if(nivel==1) {
          return parseFloat(item.additional_percentage)
        }        
        if(nivel==2) {
          return parseFloat(item.additional_percentage_1)
        }                
      },
      diffLastUpdate(item) {
        if(item.last_update_price) {
          var dateNow = moment();
          var dateLast = moment(item.last_update_price);    
          return dateNow.diff(dateLast, 'days') + 1 
        } else {
          return 1000 
        }        
      },

      // HISTORICO PRECIOS
      showHistory(item) {
        this.tableHistory.isBusy = true
        this.tableHistory.ivaAliquot = this.getItemIvaAliquot(item)
        this.itemSelectedHistory = this.itemSelected + ' - (' + item.code + ') ' + item.name
        this.tableHistory.items = item.history

        this.modal.formHistory.title = "Historial de Precios"
        this.modal.formHistory.active = true
        this.tableHistory.isBusy = false
      },
      closeHistory() {
        this.modal.formHistory.active = false
      },     

      // CONFIGURACION PRODUCTOS
      loadListsPrices() {
        this.arr.listPrices = []
        var result = serviceAPI.obtenerLista()        
        result.then((response) => {
          var data = response.data    
          data.forEach(element => {
            if(element.active) {
              this.arr.listPrices.push(element)
            }
          });
        })  
      },
      getUtility(item) {
        return item.utility / 100 
      },
      addProduct() {        
        this.itemSelectedConvert = this.itemSelected
        this.crud.formConvert.type = 'NUEVO'
        this.crud.formConvert.id = 0
        this.crud.formConvert.price_list = 0
        this.crud.formConvert.price_list_iva = 0
        this.crud.formConvert.percentage_discount = 0
        this.crud.formConvert.percentage_discount_1 = 0
        this.crud.formConvert.percentage_discount_2 = 0
        this.crud.formConvert.additional_percentage = 0
        this.crud.formConvert.additional_percentage_1 = 0
        this.crud.formConvert.additional = 0        
        this.crud.formConvert.additional_1 = 0
        this.crud.formConvert.unit_measurement_purchase = null
        this.crud.formConvert.unit_measurement_purchase_id = 18
        this.crud.formConvert.suppliers_id = (this.filterQuery['suppliers_id'] != undefined) ? this.filterQuery['suppliers_id'] : 0
        
        this.crud.formConvert.products_id = 0
        this.crud.formConvert.products = null
        this.crud.formConvert.changeType = false        
        this.crud.formConvert.unit_measurement_sale = null
        this.crud.formConvert.unit_measurement_sale_id = 18
        this.crud.formConvert.unit_measurement_sale_conversion = 1

        this.crud.formConvert.barcode = ''
        this.crud.formConvert.code = ''
        this.crud.formConvert.name = ''
        this.crud.formConvert.name_short = ''
        this.crud.formConvert.category = (this.filterQuery['category'] != undefined) ? this.filterQuery['category'] : ''
        this.crud.formConvert.subcategory = (this.filterQuery['subcategory'] != undefined) ? this.filterQuery['subcategory'] : ''
        this.crud.formConvert.line = ''
        this.crud.formConvert.subline = ''
        this.crud.formConvert.depth = 0,
        this.crud.formConvert.long = 0,
        this.crud.formConvert.height = 0,
        this.crud.formConvert.weight = 0,
        this.crud.formConvert.iva_condition = null
        this.crud.formConvert.iva_condition_id = 5      
        this.crud.formConvert.weighable = false
        this.crud.formConvert.reference_external = null

        this.arr.listPrices.forEach(element => {
          this.crud.formConvert.lists[element.id] = []
          this.crud.formConvert.lists[element.id]['add'] = true
          this.crud.formConvert.lists[element.id]['price_list_id'] = element.id
          this.crud.formConvert.lists[element.id]['utility'] = 0
          this.crud.formConvert.lists[element.id]['desc'] = 0
        })
        
        this.modal.formConvert._id = Math.random().toString(36).slice(2, 8)
        this.modal.formConvert.title = "Nuevo Producto"
        this.modal.formConvert.active = true  
      },
      editProduct(item) {       
        this.itemSelectedConvert = this.itemSelected
        this.crud.formConvert.id = item.id

        this.crud.formConvert.type = 'EDITAR'
        this.crud.formConvert.price_list = item.price_list
        var _editIva = this.getItemIvaAliquot(item)
        this.crud.formConvert.price_list_iva = Math.round(item.price_list * (1 + _editIva / 100) * 100) / 100
        this.crud.formConvert.percentage_discount = item.percentage_discount
        this.crud.formConvert.percentage_discount_1 = item.percentage_discount_1 
        this.crud.formConvert.percentage_discount_2 = item.percentage_discount_2 
        this.crud.formConvert.additional_percentage = item.additional_percentage
        this.crud.formConvert.additional_percentage_1 = item.additional_percentage_1
        this.crud.formConvert.additional = item.additional        
        this.crud.formConvert.additional_1 = item.additional_1        
        this.crud.formConvert.unit_measurement_purchase = item.unit_measurement_purchase
        this.crud.formConvert.unit_measurement_purchase_id = item.unit_measurement_purchase_id
        this.crud.formConvert.suppliers_id = item.suppliers_id
        
        this.crud.formConvert.products_id = item.products_id
        this.crud.formConvert.products = item.product
        this.crud.formConvert.changeType = false        
        this.crud.formConvert.unit_measurement_sale = item.product.unit_measurement_sale
        this.crud.formConvert.unit_measurement_sale_id = item.product.unit_measurement_sale_id
        this.crud.formConvert.unit_measurement_sale_conversion = item.product.unit_measurement_sale_conversion          

        this.crud.formConvert.barcode = item.barcode
        this.crud.formConvert.code = item.code
        this.crud.formConvert.code_system = item.product.code
        this.crud.formConvert.name = item.name
        this.crud.formConvert.name_short = item.product.name_short
        this.crud.formConvert.category = item.category
        this.crud.formConvert.subcategory = item.subcategory  
        this.crud.formConvert.line = item.line
        this.crud.formConvert.subline = item.subline
        this.crud.formConvert.depth = item.depth
        this.crud.formConvert.long = item.long
        this.crud.formConvert.height = item.height
        this.crud.formConvert.weight = item.weight
        this.crud.formConvert.iva_condition = null //no viene cargado, pero lo usa el combo
        this.crud.formConvert.iva_condition_id = item.iva_condition
        this.crud.formConvert.weighable = !!(item.product && item.product.weighable)
        this.crud.formConvert.reference_external = item.reference_external

        this.arr.listPrices.forEach(element => {
          this.crud.formConvert.lists[element.id] = []
          this.crud.formConvert.lists[element.id]['add'] = true
          this.crud.formConvert.lists[element.id]['price_list_id'] = 0
          this.crud.formConvert.lists[element.id]['utility'] = 0
          this.crud.formConvert.lists[element.id]['desc'] = 0
        })

        this.arr.listPrices.forEach(element => {
          if(this.crud.formConvert.products_id) {
            var result1 = serviceAPI.mostrarProductosByLista({
              price_list_id: element.id,
              products_id: this.crud.formConvert.products_id,
            })        
            result1.then((response1) => {
              var data1 = response1.data

              this.crud.formConvert.lists[element.id]['add'] = true
              this.crud.formConvert.lists[element.id]['price_list_id'] = parseFloat(data1.products.price_list_id)
              this.crud.formConvert.lists[element.id]['utility'] = parseFloat(data1.products.utility)
              this.crud.formConvert.lists[element.id]['desc'] = parseFloat(data1.products.desc)
              this.convertPriceForceUpdate()
            }).catch(() => {    
              this.crud.formConvert.lists[element.id]['add'] = false
              this.crud.formConvert.lists[element.id]['price_list_id'] = parseFloat(element.id)
              this.crud.formConvert.lists[element.id]['utility'] = 0
              this.crud.formConvert.lists[element.id]['desc'] = 0
              this.convertPriceForceUpdate()
            })                                                   
          }
        });

        this.modal.formConvert._id = Math.random().toString(36).slice(2, 8)
        this.modal.formConvert.title = "Editar Producto"
        this.modal.formConvert.active = true        
      },
      changeTypeConvert() {
        if(this.crud.formConvert.type == 'NUEVO') {
          this.crud.formConvert.products_id = 0
          this.crud.formConvert.products = null
        }
        if(this.crud.formConvert.type == 'EDITAR') {
          this.crud.formConvert.code = ''
        }        
      },
      loadProductsConvert(object) {
        if(object){
          this.crud.formConvert.products = object
          this.crud.formConvert.products_id = object.id
        } else {
          this.crud.formConvert.products = null
          this.crud.formConvert.products_id = 0
        }
      },
      loadUnitMeasurementPurchase(object) {
        if(object){
          this.crud.formConvert.unit_measurement_purchase = object
          this.crud.formConvert.unit_measurement_purchase_id = object.id  
        } else {
          this.crud.formConvert.unit_measurement_purchase = null
          this.crud.formConvert.unit_measurement_purchase_id = 0
        }
      },
      loadUnitMeasurementSale(object) {
        if(object){
          this.crud.formConvert.unit_measurement_sale = object
          this.crud.formConvert.unit_measurement_sale_id = object.id
        } else {
          this.crud.formConvert.unit_measurement_sale = null
          this.crud.formConvert.unit_measurement_sale_id = 0
        }
      }, 
      loadIvaConditions (object) {
        if(object){
          this.crud.formConvert.iva_condition = object
          this.crud.formConvert.iva_condition_id = object.id             
        } else {
          this.crud.formConvert.iva_condition = null
          this.crud.formConvert.iva_condition_id = 0
        }
      },                 
      saveProduct() {  
        var modalTitle = ''      
        var modalContent = ''

        if(this.crud.formConvert.type=='EDITAR') {
          if(!this.crud.formConvert.products_id) {
            this.$awn.alert("No se cargó la relación con el producto");
            return false
          }

          modalTitle = '¿Continuar con la edición del producto?'
          modalContent = 'Editar Producto'
        }

        if(this.crud.formConvert.type=='NUEVO') {
          if(!this.crud.formConvert.code) {            
            this.$awn.alert("No se cargo el código");
            return false            
          }

          modalTitle = '¿Agregar el nuevo producto?'
          modalContent = 'Agregar Producto'          
        }        
        
        this.confirmDialog(modalContent, {
          title: modalTitle,
          icon: 'save',
          okTitle: 'GUARDAR',
        })
        .then(value => {          
          if (value) {            
            let loader = this.$loading.show();
            
            // preparar datos
            var lists = this.crud.formConvert.lists
            this.crud.formConvert.lists = []
            
            lists.forEach(element => {
              this.crud.formConvert.lists.push({
                add: element.add,
                price_list_id: element.price_list_id, 
                utility: element.utility, 
                desc: element.desc
              })
            });
            // fin preparar datos
            if(!this.parameters.enableProductShortName) {
              this.crud.formConvert.name_short = this.crud.formConvert.name
            }
            
            if(this.priceWithIva) {
              var _saveIvaId = this.crud.formConvert.iva_condition_id
              var _saveCond = this.arr.fiscalCondition.find(c => c.id === _saveIvaId)
              var _saveIva = _saveCond ? parseFloat(_saveCond.aliquot || _saveCond.percentage || 0) : 0
              this.crud.formConvert.price_list = _saveIva > 0
                ? Math.round(this.crud.formConvert.price_list_iva / (1 + _saveIva / 100) * 100) / 100
                : this.crud.formConvert.price_list_iva
            }

            var result = serviceAPI.saveProduct(this.crud.formConvert);

            result.then((response) => {
              this.modal.formConvert.active = false              
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Registro configurado con éxito");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })            
      },
      convertPriceForceUpdate() {
        this.convertPriceForceUpdateKey = this.convertPriceForceUpdateKey + 1
      },
      loadSuppliersAddProduct(object) {
        if(object){
          this.crud.formConvert.suppliers = object
          this.crud.formConvert.suppliers_id = object.id
        } else {
          this.crud.formImport.suppliers = null
          this.crud.formImport.suppliers_id = 0
        }
      },      

      // REFERENCIA EXTERNAL DEDSE BASE DE DATOS
      loadReferenceExternal(object) {                
        if(object){
          this.crud.formConvert.reference_external = object.reference          
        } else {
          if(!this.crud.formConvert.reference_external) {
            this.crud.formConvert.reference_external = null
          }          
        }
      },   

      // MARCAR POR DEFAULT
      setDefault(item) {        
        this.confirmDialog('¿Marcar producto de proveedor por Default para obtener el precio de venta?', {
          title: 'Marcar Por Default',
          icon: 'radio_button_checked',
          okTitle: 'MARCAR',
        })
        .then(value => {          
          if (value) {            
            let loader = this.$loading.show();
            
            var result = serviceAPI.marcarDefault({
              id: item.id
            });

            result.then((response) => {                            
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Registro marcado con éxito");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })    
      },

      // COMPARAR PRECIOS
      showCompare(item) {
        this.tableCompare.isBusy = true
        this.tableCompare.ivaAliquot = this.getItemIvaAliquot(item)
        this.itemSelectedCompare = '(' + item.product.code + ') ' + item.product.name
                
        var result = serviceAPI.compareProductos({
          products_id: item.products_id,
        })        
        result.then((response) => {
          var data = response.data
          this.tableCompare.items = data        
        })                  

        this.modal.formCompare.title = "Comparar precios con otros proveedores"
        this.modal.formCompare.active = true
        this.tableCompare.isBusy = false
      },
      closeCompare() {
        this.modal.formCompare.active = false
      },
      formatNumber(valor) {
        return valor.toLocaleString()
      },

      // CAMBIO DE PRECIOS
      initChangePrice() {
        this.statusEditPrice = true;
        this.$awn.warning("Iniciando edición de precios");        
      },
      endChangePrice() {
        this.statusEditPrice = false;
        this.$awn.warning("Finalizando edición de precios");
      },     
      confirmSavePriceInline(item) {
        if(!item) return
        this.modal.confirmSavePrice.item = item
        this.modal.confirmSavePrice.active = true
      },
      confirmSavePriceConfirmed() {
        this.modal.confirmSavePrice.active = false
        this.savePrice(this.modal.confirmSavePrice.item)
        this.modal.confirmSavePrice.item = null
      },
      onPriceBlur(item) {
        if(!item) return
        if(this.priceWithIva) {
          let current = this.normalizeNumber(item.price_list_iva)
          let original = this.normalizeNumber(item.price_list_iva_original)
          if(current !== original) {
            this.savePrice(item, true)
          }
        } else {
          let current = this.normalizeNumber(item.price_list)
          let original = this.normalizeNumber(item.price_list_original)
          if(current !== original) {
            this.savePrice(item, true)
          }
        }
      },
      savePrice(item, silent = false) {
        if(!item) return

        var priceListToSave = this.normalizeNumber(item.price_list)
        if(this.priceWithIva) {
          var rowItem = this.table.items.find(r => r.id === item.id)
          var iva = rowItem ? this.getItemIvaAliquot(rowItem) : 0
          var priceIva = this.normalizeNumber(item.price_list_iva)
          priceListToSave = iva > 0 ? Math.round(priceIva / (1 + iva / 100) * 100) / 100 : priceIva
          item.price_list = priceListToSave
        }

        var result = serviceAPI.updateProducto({
          id: item.id,
          product_id: item.product_id,
          price_list: priceListToSave,
        })
                      
        result.then((response) => {
          item.price_list_original = this.normalizeNumber(item.price_list)
          item.price_list_iva_original = this.normalizeNumber(item.price_list_iva)

          let row = this.table.items.find(r => r.id === item.id)
          if(row) {
            row.price_list = this.normalizeNumber(item.price_list)
            row.last_update_price = response.data && response.data.last_update_price ? response.data.last_update_price : row.last_update_price
            row.price_cost = this.calcPriceCost(row)
            if(row.history) {
              row.history.unshift({
                price_list: row.price_list,
                price_cost: row.price_cost,
                percentage_discount: row.percentage_discount,
                percentage_discount_1: row.percentage_discount_1,
                percentage_discount_2: row.percentage_discount_2,
                additional: row.additional,
                additional_1: row.additional_1,
                additional_percentage: row.additional_percentage,
                additional_percentage_1: row.additional_percentage_1,
                unit_measurement_purchase_id: row.unit_measurement_purchase_id,
                unit_measurement_purchase: row.unit_measurement_purchase,
                date: moment().format(),
                created_at: moment().format(),
              })
            }
          }

          if(!silent)
            this.$awn.success("Precio de lista actualizado")
        })
        .catch(error => {                              
          item.price_list = item.price_list_original
          this.$awn.alert(Error.showError(error));
        })  
      },
      restorePriceInline(item, index) {
        if(!this.canUndoPrice(item)) {
          return
        }

        this.confirmDialog('¿Restaurar el precio anterior desde el historial? Esta acción eliminará el último registro del historial.', {
          title: 'Restaurar precio',
          icon: 'undo',
          danger: true,
          okTitle: 'RESTAURAR',
        })
        .then(value => {
          if(!value) return

          var result = serviceAPI.undoPrice({
            id: item.id
          })
                        
          result.then(() => {
            if(item.history && item.history.length > 1) {
              item.history.shift()
              let current = item.history[0]
              if(current) {
                item.price_list = this.normalizeNumber(current.price_list)
                item.last_update_price = current.created_at || item.last_update_price
                item.price_cost = this.calcPriceCost(item)
              }
            }

            var restoredIva = this.getItemIvaAliquot(item)
            var restoredPlIva = Math.round(item.price_list * (1 + restoredIva / 100) * 100) / 100

            let tmp = this.crud.prodTMP[index] || this.crud.prodTMP.find(t => t.id === item.id)
            if(tmp) {
              tmp.price_list = item.price_list
              tmp.price_list_original = item.price_list
              tmp.price_list_iva = restoredPlIva
              tmp.price_list_iva_original = restoredPlIva
            }

            this.$awn.success("Precio restaurado")
          })
          .catch(error => {                                            
            this.$awn.alert(Error.showError(error));
          })   
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },
      canUndoPrice(item) {
        return item && item.history && item.history.length > 1
      },
      getUndoTitle(item) {
        if(!this.canUndoPrice(item)) {
          return 'Sin historial para restaurar'
        }
        let prev = item.history[1]
        let priceNoIva = prev && prev.price_list ? prev.price_list : 0
        let price = priceNoIva
        if(this.priceWithIva) {
          var iva = this.getItemIvaAliquot(item)
          price = iva > 0 ? Math.round(priceNoIva * (1 + iva / 100) * 100) / 100 : priceNoIva
        }
        let dateValue = prev && (prev.created_at || prev.date) ? (prev.created_at || prev.date) : null
        let dateText = dateValue ? moment(dateValue).format('DD/MM/YYYY HH:mm') : 's/d'
        let priceText = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(price)
        let ivaLabel = this.priceWithIva ? ' c/IVA' : ''
        return 'Restaurar a ' + priceText + ivaLabel + ' (' + dateText + ')'
      },
      calcPriceCost(item) {
        let price = this.normalizeNumber(item.price_list)
        price += this.normalizeNumber(item.additional)
        let discount = this.normalizeNumber(item.percentage_discount)
        if(discount) price -= (price * discount) / 100
        discount = this.normalizeNumber(item.percentage_discount_1)
        if(discount) price -= (price * discount) / 100
        discount = this.normalizeNumber(item.percentage_discount_2)
        if(discount) price -= (price * discount) / 100
        let additional = this.normalizeNumber(item.additional_percentage)
        if(additional) price += (price * additional) / 100
        additional = this.normalizeNumber(item.additional_percentage_1)
        if(additional) price += (price * additional) / 100
        price += this.normalizeNumber(item.additional_1)
        if (this.hasRoundPriceUp) {
          let m = this.parameters.roundingMultiple
          return m > 0 ? Math.ceil(price / m) * m : Math.ceil(price)
        }
        return Math.round(price * 100) / 100
      },
      
      // ELIMINAR PRODUCTO
      deleteProduct(item) {
        this.confirmDialog('¿Eliminar el producto ['+item.code + '] - ' + item.name + '?', {
          title: 'Eliminar producto',
          icon: 'delete',
          danger: true,
          okTitle: 'ELIMINAR',
          cancelTitle: 'NO',
        })
        .then(value => {
          if (value) {
            var result = serviceAPI.deleteProducto({
              id: item.id,              
            })
                          
            result.then((response) => {                                  
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)              

              this.$awn.success("Producto eliminado");
            })
            .catch(error => {                              
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)                         
              this.$awn.alert(Error.showError(error));
            })  
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })  
      },

      // EDITAR LOTE
      showEditPriceLote() {
        this.modal.formEditPriceLote.title = "Edición de precios por lotes"
        this.modal.formEditPriceLote.active = true

        this.crud.formEditPriceLote.percentage = 0
        this.crud.formEditPriceLote.operations = '+'
        this.crud.formEditPriceLote.filterQuery = []        
      },
      closeEditPriceLote() {
        this.modal.formEditPriceLote.active = false
      },      
      saveEditPriceLote() {                       
        if(parseFloat(this.crud.formEditPriceLote.percentage) <= 0) {
          this.$awn.alert("El porcentaje debe ser mayor a cero");
          return false
        }
        
        this.confirmDialog('¿Actualizar todos los precio un ' + this.crud.formEditPriceLote.percentage + '%?', {
          title: 'Actualización Precios',
          icon: 'percent',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO',
        })
        .then(value => {          
          if (value) {  
            let loader = this.$loading.show();        
                    
            this.crud.formEditPriceLote.filterQuery = this.filterQuery
            this.crud.formEditPriceLote.filterQuery.paginate = false

            var result = serviceAPI.updateProductoLote(this.crud.formEditPriceLote)
                          
            result.then((response) => {                                                                                                                
              this.modal.formEditPriceLote.active = false   

              this.crud.formEditPriceLote.percentage = 0
              this.crud.formEditPriceLote.operations = '+'
              this.crud.formEditPriceLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true, true, 'Precios actualizados '+ this.crud.formEditPriceLote.percentage + '%')                                                          
            })
            .catch(error => {                              
              this.modal.formEditPriceLote.active = false 
              
              this.crud.formEditPriceLote.percentage = 0
              this.crud.formEditPriceLote.operations = '+'
              this.crud.formEditPriceLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true)
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));          
        })  
      },

      // DESCUENTO LOTE
      showEditDiscountLote() {
        this.modal.formEditDiscountLote.title = "Configuración de descuentos"
        this.modal.formEditDiscountLote.active = true

        this.crud.formEditDiscountLote.discount1 = 0              
        this.crud.formEditDiscountLote.discount2 = 0              
        this.crud.formEditDiscountLote.discount3 = 0              
        this.crud.formEditDiscountLote.filterQuery = []        
      },
      closeEditDiscountLote() {
        this.modal.formEditDiscountLote.active = false        
      },      
      saveEditDiscountLote() {        
        if(isNaN(parseFloat(this.crud.formEditDiscountLote.discount1)) || isNaN(parseFloat(this.crud.formEditDiscountLote.discount2)) || isNaN(parseFloat(this.crud.formEditDiscountLote.discount3))) {
          this.$awn.alert("Revise los valores enviados, deben ser de tipo numérico.");
          return false
        }
        
        this.confirmDialog('¿Continuar con la actualización de descuentos para los productos filtrados?', {
          title: 'Actualización Descuentos',
          icon: 'sell',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO',
        })
        .then(value => {          
          if (value) {  
            let loader = this.$loading.show();        
                    
            this.crud.formEditDiscountLote.filterQuery = this.filterQuery
            this.crud.formEditDiscountLote.filterQuery.paginate = false

            var result = serviceAPI.updateProductoDescuentoLote(this.crud.formEditDiscountLote)
                          
            result.then((response) => {                                                                                                                
              this.modal.formEditDiscountLote.active = false   

              this.crud.formEditDiscountLote.discount1 = 0              
              this.crud.formEditDiscountLote.discount2 = 0              
              this.crud.formEditDiscountLote.discount3 = 0              
              this.crud.formEditDiscountLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true, true, 'Descuentos actualizados')                                                          
            })
            .catch(error => {                              
              this.modal.formEditDiscountLote.active = false 
              
              this.crud.formEditDiscountLote.discount1 = 0              
              this.crud.formEditDiscountLote.discount2 = 0              
              this.crud.formEditDiscountLote.discount3 = 0              
              this.crud.formEditDiscountLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true)
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));          
        })          
      },

      // LISTAS DE PRECIOS (SIDEBAR)
      openPriceListEditor(item) {
        if(!item || !item.products_id || !item.product) {
          this.$awn.alert("El producto no está vinculado a un producto de venta");
          return false
        }

        if(this.priceListEditor.active &&
           this.priceListEditor.dirty &&
           this.priceListEditor.selectedId &&
           this.priceListEditor.selectedId !== item.id) {
          this.$awn.warning("Hay cambios sin guardar. Guarde o cancele los cambios para continuar.");
          return
        }

        this.priceListEditor.active = true
        this.priceListEditor.loading = true
        this.priceListEditor.product = item
        this.priceListEditor.productLabel = '(' + item.product.code + ') ' + item.product.name
        this.priceListEditor.selectedId = item.id

        this.buildPriceListEditor(item)
        this.priceListEditor.loading = false
      },
      buildPriceListEditor(item) {
        let priceMap = {}
        if(item.product && item.product.prices) {
          item.product.prices.forEach(price => {
            priceMap[price.price_list_id] = price
          })
        }

        this.priceListEditor.lists = this.arr.listPrices.map(list => {
          let price = priceMap[list.id]
          let utility = price ? this.normalizeNumber(price.utility) : 0
          let desc = price ? this.normalizeNumber(price.desc) : 0
          return {
            id: list.id,
            name: list.name,
            currency: list.currency ? list.currency.code : '',
            default_utility: this.normalizeNumber(list.utility),
            active: !!price,
            price_list_product_id: price ? price.id : 0,
            utility: utility,
            desc: desc,
            last_saved_utility: utility,
            last_saved_desc: desc,
            dirty: false,
            saving: false,
          }
        })
        this.priceListEditor.dirty = false
      },
      addPriceList(list) {
        let productId = this.priceListEditor.product ? this.priceListEditor.product.products_id : 0
        if(!productId) {
          this.$awn.alert("Producto no disponible")
          return false
        }

        list.saving = true
        var result = serviceAPI.agregarPrecioListaProducto({
          price_list_id: list.id,
          products_id: productId,
          utility: this.normalizeNumber(list.utility),
          desc: this.normalizeNumber(list.desc),
          amount: 0
        })

        result.then((response) => {
          let data = response.data
          list.active = true
          list.price_list_product_id = data.id
          list.last_saved_utility = this.normalizeNumber(list.utility)
          list.last_saved_desc = this.normalizeNumber(list.desc)
          list.dirty = false
          list.saving = false
          this.recomputeDirty()
          this.syncProductPrices(list)
          this.$awn.success("Lista agregada")
        })
        .catch(error => {
          list.saving = false
          list.active = false
          this.$awn.alert(Error.showError(error))
        })
      },
      togglePriceList(list) {
        if(list.saving) {
          return
        }

        if(list.active) {
          this.addPriceList(list)
        } else {
          this.removePriceList(list)
        }
      },
      savePriceList(list) {
        this.saveAllPriceLists()
      },
      saveAllPriceLists() {
        let lists = this.priceListEditor.lists.filter(l => l.active)
        if(!lists.length) {
          this.$awn.info("No hay listas activas para guardar")
          return
        }

        let errors = []
        let promises = []

        lists.forEach(list => {
          list.saving = true

          if(!list.price_list_product_id) {
            let req = serviceAPI.agregarPrecioListaProducto({
              price_list_id: list.id,
              products_id: this.priceListEditor.product.products_id,
              utility: this.normalizeNumber(list.utility),
              desc: this.normalizeNumber(list.desc),
              amount: 0
            })
            promises.push(
              req.then((response) => {
                let data = response.data
                list.price_list_product_id = data.id
                list.last_saved_utility = this.normalizeNumber(list.utility)
                list.last_saved_desc = this.normalizeNumber(list.desc)
                list.dirty = false
                this.syncProductPrices(list)
              }).catch(error => {
                errors.push(error)
              }).finally(() => {
                list.saving = false
              })
            )
          } else {
            let req = serviceAPI.editarPrecioListaProducto({
              id: list.price_list_product_id,
              utility: this.normalizeNumber(list.utility),
              desc: this.normalizeNumber(list.desc),
            })
            promises.push(
              req.then(() => {
                list.last_saved_utility = this.normalizeNumber(list.utility)
                list.last_saved_desc = this.normalizeNumber(list.desc)
                list.dirty = false
                this.syncProductPrices(list)
              }).catch(error => {
                errors.push(error)
              }).finally(() => {
                list.saving = false
              })
            )
          }
        })

        Promise.all(promises).then(() => {
          this.recomputeDirty()
          if(errors.length) {
            this.$awn.alert("Algunas listas no se pudieron guardar")
          } else {
            this.$awn.success("Listas actualizadas")
          }
        })
      },
      removePriceList(list) {
        if(!list.price_list_product_id) {
          list.active = false
          return
        }

        list.saving = true
        var result = serviceAPI.eliminarPrecioListaProducto(list.price_list_product_id)
        result.then(() => {
          list.saving = false
          list.active = false
          list.price_list_product_id = 0
          list.dirty = false
          this.recomputeDirty()
          this.syncProductPrices(list)
          this.$awn.success("Lista quitada")
        })
        .catch(error => {
          list.saving = false
          list.active = true
          this.$awn.alert(Error.showError(error))
        })
      },
      markListDirty(list) {
        this.updateDirtyState(list)
      },
      cancelPriceListChanges() {
        if(!this.priceListEditor.dirty) {
          return
        }
        this.priceListEditor.lists.forEach(list => {
          list.utility = this.normalizeNumber(list.last_saved_utility)
          list.desc = this.normalizeNumber(list.last_saved_desc)
          list.dirty = false
        })
        this.priceListEditor.dirty = false
        this.$awn.info("Cambios cancelados")
      },
      updateDirtyState(list) {
        if(!list.active) {
          list.dirty = false
        } else {
          let utility = this.normalizeNumber(list.utility)
          let desc = this.normalizeNumber(list.desc)
          list.dirty = (utility !== this.normalizeNumber(list.last_saved_utility)) ||
                       (desc !== this.normalizeNumber(list.last_saved_desc))
        }
        this.recomputeDirty()
      },
      recomputeDirty() {
        this.priceListEditor.dirty = this.priceListEditor.lists.some(l => l.dirty)
      },
      goPrevProduct() {
        if(!this.canGoPrevProduct) {
          return
        }
        let nextItem = this.table.items[this.currentPriceListIndex - 1]
        if(nextItem) {
          this.openPriceListEditor(nextItem)
        }
      },
      goNextProduct() {
        if(!this.canGoNextProduct) {
          return
        }
        let nextItem = this.table.items[this.currentPriceListIndex + 1]
        if(nextItem) {
          this.openPriceListEditor(nextItem)
        }
      },
      syncProductPrices(list) {
        if(!this.priceListEditor.product || !this.priceListEditor.product.product) {
          return
        }

        if(!this.priceListEditor.product.product.prices) {
          this.$set(this.priceListEditor.product.product, 'prices', [])
        }

        let prices = this.priceListEditor.product.product.prices
        let idx = prices.findIndex(p => p.price_list_id === list.id)

        if(list.active) {
          let merged = idx >= 0 ? Object.assign({}, prices[idx]) : {}
          merged.id = list.price_list_product_id
          merged.price_list_id = list.id
          merged.utility = this.normalizeNumber(list.utility)
          merged.desc = this.normalizeNumber(list.desc)

          if(idx >= 0) {
            this.$set(prices, idx, merged)
          } else {
            prices.push(merged)
          }
        } else if(idx >= 0) {
          prices.splice(idx, 1)
        }
      },
      loadPriceWithIvaPreference() {
        try {
          var stored = localStorage.getItem('bcsp_prefs')
          var prefs = stored ? JSON.parse(stored) : {}
          this.priceWithIva = !!prefs.priceWithIva
        } catch (e) { /* localStorage no disponible */ }
      },
      savePriceWithIvaPreference() {
        try {
          var stored = localStorage.getItem('bcsp_prefs')
          var prefs = stored ? JSON.parse(stored) : {}
          prefs.priceWithIva = this.priceWithIva
          localStorage.setItem('bcsp_prefs', JSON.stringify(prefs))
        } catch (e) { /* localStorage no disponible */ }
      },
      onPriceWithIvaToggle() {
        this.savePriceWithIvaPreference()
      },
      getItemIvaAliquot(item) {
        if(!this.arr.fiscalCondition || !this.arr.fiscalCondition.length) return 0
        var condId = (item && item.iva_condition) || (item && item.product && item.product.erp_iva_condition_id) || 0
        if(!condId) return 0
        var cond = this.arr.fiscalCondition.find(c => c.id === condId)
        return cond ? parseFloat(cond.aliquot || cond.percentage || 0) : 0
      },
      formatCurrency(value) {
        return Intl.NumberFormat('es-AR', {style:'currency', currency: this.getCurrency}).format(this.normalizeNumber(value))
      },
      getPriceListOppositeTitle(item, editItem = null) {
        var iva = this.getItemIvaAliquot(item)
        if(this.priceWithIva) {
          var priceIva = this.normalizeNumber(editItem ? editItem.price_list_iva : (item.price_list * (1 + iva / 100)))
          var priceNoIva = iva > 0 ? Math.round(priceIva / (1 + iva / 100) * 100) / 100 : priceIva
          return 'Precio s/IVA: ' + this.formatCurrency(priceNoIva)
        }

        var price = this.normalizeNumber(editItem ? editItem.price_list : item.price_list)
        var priceWithIva = Math.round(price * (1 + iva / 100) * 100) / 100
        return 'Precio c/IVA: ' + this.formatCurrency(priceWithIva)
      },
      getPriceCostOppositeTitle(item) {
        var iva = this.getItemIvaAliquot(item)
        var priceCost = this.normalizeNumber(item ? item.price_cost : 0)
        var priceCostWithIva = Math.round(priceCost * (1 + iva / 100) * 100) / 100
        return 'Precio de compra s/IVA: ' + this.formatCurrency(priceCost) + ' | Precio de compra c/IVA: ' + this.formatCurrency(priceCostWithIva)
      },
      normalizeNumber(value) {
        let num = parseFloat(value)
        return isNaN(num) ? 0 : num
      },
      formatPercent(value) {
        return Intl.NumberFormat('es-AR', {style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.normalizeNumber(value) / 100)
      },
      
      // PRECIOS DE VENTA
      setPricesProducts(item) {                
        this.tablePrices.items = item.product.prices
        this.itemSelectedPrice = item

        this.modal.formPrice.active = true
        this.modal.formPrice.title = "Precios de Venta"        
      },
      sumDiscountPrice(amount, desc, item = null, action = 'viewCalc') {             
        if(item && item.unit_measurement_initial && item.unit_measurement_result && item.unit_measurement_initial.id != item.unit_measurement_result.id) {        
          if(action == 'viewCalc') {           
            if(parseFloat(item.amount_initial) == parseFloat(amount)) {
              return parseFloat(item.amount_initial)
            } else {
              if(desc) {
                var base1 = (100 - parseFloat(desc)) / 100                
                if(parseFloat(base1) == 0) {                            
                  return parseFloat(amount)
                } else {                              
                  return parseFloat(amount) / base1
                }                        
              } else {            
                return parseFloat(amount)
              }
            }          
          }           
        } else {    
          if(action == 'viewCalc') {        
            if(desc) {
              var base2 = (100 - parseFloat(desc)) / 100                
              if(parseFloat(base2) == 0) {                            
                return parseFloat(amount)
              } else {              
                return parseFloat(amount) / base2
              }                        
            } else {            
              return parseFloat(amount)
            }   
          }         
        }     
      },      
      selectPriceSalesDefault() {              
        this.modal.formPriceSaleDefault.active = true
        this.modal.formPriceSaleDefault.title = "Precio de venta por defecto"        
      },
      loadPriceList(object) {
        if(object){
          this.crud.formPriceSaleDefault.price_list = object
          this.crud.formPriceSaleDefault.price_list_id = object.id             
        } else {
          this.crud.formPriceSaleDefault.price_list = null
          this.crud.formPriceSaleDefault.price_list_id = 0
        }
      },
      savePriceSalesDefault() {        
        this.saveFilterStorage()
        this.restoreFilterStorage()
        this.loadFieldTable()

        this.modal.formPriceSaleDefault.active = false
                
        this.selectedItem(this.filterQuery, true)        
      },  

      // FILTERS
      loadFilterByWidget() {
        let widget = this.$route && this.$route.params ? this.$route.params.widget : null
        let fromStorage = false
        if(!widget && Storage.getValue('costs_price_list_widget')) {
          try {
            widget = JSON.parse(Storage.getValue('costs_price_list_widget'))
            fromStorage = true
          } catch(e) {
            widget = null
          }
        }

        if(widget) {
          
          // El proveedor recibido del editor restablece el contexto de
          // productos, no el filtro manual del árbol. Así el árbol continúa
          // mostrando todos los proveedores al volver de una importación.
          let filterTreeSupplierID = widget.suppliers_id                  

          let filterTableSupplierID = widget.suppliers_id
          if(filterTableSupplierID) {
            this.filterQuery.suppliers_id = filterTableSupplierID
          }  
          let filterTableCategory = widget.category
          if(filterTableCategory) {
            this.filterQuery.category = filterTableCategory
          }  
          let filterTableSubcategory = widget.subcategory
          if(filterTableSubcategory) {
            this.filterQuery.subcategory = filterTableSubcategory
          }  
          let filterTableCode = widget.code
          if(filterTableCode) {
            this.filterQuery.text = filterTableCode
          }
          let filterTableLastUpdate = widget.lastUpdate
          if(filterTableLastUpdate) {
            this.filterQuery.lastUpdate = filterTableLastUpdate
          }                       
          if(widget.suppliers_label) {
            this.itemSelected = widget.suppliers_label.toUpperCase()
          } else if(filterTreeSupplierID) {
            const supplierMatch = this.arr.filters.suppliers.find(s => s.code === filterTreeSupplierID)
            if(supplierMatch && supplierMatch.label) {
              this.itemSelected = supplierMatch.label.toUpperCase()
            }
          }
          this.selectedItem(this.filterQuery,true)

          if(fromStorage) {
            Storage.removeValue('costs_price_list_widget')
          }
        }                     
      },

      // PRECIOS ACCIONES
      sincroPrice(item) {
        this.confirmDialog('¿Sincronizar precio con lista del proveedor. Producto ['+item.code + '] - ' + item.name + '?', {
          title: 'Sincronizar precio',
          icon: 'refresh',
          okTitle: 'SINCRONIZAR',
          cancelTitle: 'NO',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();        

            var result = serviceAPI.sincroPrice({
              id: item.id
            })
                          
            result.then((response) => {                                                                                                                              
              loader.hide()
            
              if(response.data) {
                this.$awn.success("Precio sincronizado");                    
                this.selectedItem(this.filterQuery, true)
              } else {
                this.$awn.info("El precio actual ya se encuentra actualizado");                                    
              }
            })
            .catch(error => {                                            
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      }, 
      undoPrice(item) {
        this.confirmDialog('¿Deshacer precio actual por el anterior en el historial. Producto ['+item.code + '] - ' + item.name + '?', {
          title: 'Deshacer precio',
          icon: 'undo',
          danger: true,
          okTitle: 'DESHACER',
          cancelTitle: 'NO',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();        

            var result = serviceAPI.undoPrice({
              id: item.id
            })
                          
            result.then((response) => {                                                                                                                
              loader.hide()
              this.$awn.success("Precio actualizado");      
              
              this.selectedItem(this.filterQuery, true)
            })
            .catch(error => {                                            
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // PARSER HTML
      loadFiscalCondition() {
        this.arr.fiscalCondition = []
        var result = serviceAPI.obtenerCondicionesIva()        
        result.then((response) => {
          var data = response.data            
          data.forEach(element => {            
            this.arr.fiscalCondition.push(element)            
          });
        })  
      },
      showParseExtras(item) {
        let html = ""
        var iva = this.getItemIvaAliquot(item)
        var withIva = this.priceWithIva && iva > 0
        var factor = withIva ? (1 + iva / 100) : 1
        var ivaLabel = withIva ? ' (c/IVA)' : ''

        html = html + "<b><u>COMPOSICION PRECIO DE COSTO</u></b><hr>";
        html = html + "Precio de Lista" + ivaLabel + ": <span class='pull-right'> <b>" + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(item.price_list * factor) + "</b></span><hr>";

        if(parseFloat(item.additional)>0) {
          html = html + "Adiccional: <span class='pull-right'> + " + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(item.additional) + "</span><hr>";  
        }

        if(this.getDiscount(item,1)) {
          html = html + "Descuento 1: <span class='pull-right'> -" + Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getDiscount(item,1) / 100) + "</span> <br>";  
        }
        if(this.getDiscount(item,2)) {
          html = html + "Descuento 2: <span class='pull-right'> -" + Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getDiscount(item,2) / 100) + "</span> <br>";
        }
        if(this.getDiscount(item,3)) {
          html = html + "Descuento 3: <span class='pull-right'> -" + Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getDiscount(item,3) / 100) + "</span> <br>";
        }
        if(this.getDiscount(item,1) || this.getDiscount(item,2) || this.getDiscount(item,3)) {
          html = html + "<hr>";
        }

        if(this.getAdditional(item,1)) {
          html = html + "Adiccional 1: <span class='pull-right'> +" + Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getAdditional(item,1) / 100) + "</span><br>";  
        }        
        if(this.getAdditional(item,2)) {
          html = html + "Adiccional 2: <span class='pull-right'> +" + Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.getAdditional(item,2) / 100) + "</span><br>";  
        }
        if(this.getAdditional(item,1) || this.getAdditional(item,2)) {
          html = html + "<hr>";
        }    

        if(parseFloat(item.additional_1) > 0) {
          html = html + "Adiccional: <span class='pull-right'> +" + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(item.additional_1)  + "</span><hr>";  
        }

        var priceCostNoIva = this.normalizeNumber(item.price_cost)
        var priceCostWithIva = Math.round(priceCostNoIva * (1 + iva / 100) * 100) / 100
        html = html + "<div class='cpls-cost-final-row cpls-cost-final-row--no-iva'>Precio de Compra s/IVA: <span class='pull-right'><b>" + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(priceCostNoIva) + "</b></span></div>";
        html = html + "<div class='cpls-cost-final-row cpls-cost-final-row--iva'>Precio de Compra c/IVA: <span class='pull-right'><b>" + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency }).format(priceCostWithIva) + "</b></span></div>";

        return html        
      },      
      showParsePriceSales(item) {                        
        let html = ""                
        let utility = item.list.utility
        if(item.utility>0) {
          utility = item.utility
        }
        html = html + "<b>LISTA:</b> " + item.list.name + " (" + item.list.currency.code + ") <br>";
        html = html + "<b>UTIL:</b> " + parseFloat(utility).toFixed(2) + "% <b>DESC:</b> " + item.desc + "%<br>";                 
        if(parseFloat(item.unit_measurement_surcharge_equivalence)>0) { 
          html = html + "<hr>";
          html = html + "<b>EQUIVALENCIA:</b> " + item.unit_measurement_surcharge_equivalence + "%";          
        }
        
        return html
      },
      showParsePriceIvaSales(item, product) {
        // 'product' es data.item.product (viene del template): la relación 'products' de
        // PriceListProducts está oculta a propósito en el modelo, así que item.products
        // siempre es undefined -- hay que resolver la condición de IVA desde afuera.
        let condId = (product && product.erp_iva_condition_id) || 0
        let iva = this.arr.fiscalCondition.find(c => c.id === condId)

        let html = ""
        html = html + "<b>COND. IVA:</b> " + (iva ? iva.name : '-') + "<hr>";

        let utility = item.list.utility
        if(item.utility>0) {
          utility = item.utility
        }
        html = html + "<b>LISTA:</b> " + item.list.name + " (" + item.list.currency.code + ") <br>";
        html = html + "<b>UTIL:</b> " + parseFloat(utility).toFixed(2) + "% <b>DESC:</b> " + item.desc + "%<br>";
        if(parseFloat(item.unit_measurement_surcharge_equivalence)>0) {
          html = html + "<hr>";
          html = html + "<b>EQUIVALENCIA:</b> " + item.unit_measurement_surcharge_equivalence + "%";                         
        }
        
        return html
      },
      showParseReferenceExternal(item) {                        
        let html = ""                
        if(item.category && item.subcategory) {
          html = html + "" + item.category + " > " + item.subcategory + "<hr>";                
        }        
        if(item.line && item.subline) {
          html = html + "<b>LINEA:</b> " + item.line + ' <br> ' + item.subline + "<hr>";              
        }                
        html = html + "<u><b>" + item.code + "</b></u> - " + item.name + "<br>";        
        if(item.barcode) {
          html = html + "<hr>" + "<b>CODIGO DE BARRA:</b> <br>" + item.barcode;        
        }
        if(item.reference_external) {
          html = html + "<hr>" + "<b>REFERENCIA EXTERNA:</b> <br>" + item.reference_external;        
        }
        return html
      },     
      showRaisePrice(item) {
        let html = ""
        if(item.history && item.history[1]) {
          if(this.diffLastUpdate(item) <= 15) {
            let _lastUpdateAnt = moment(item.history[1].created_at)          
            let _lastUpdateNow = moment(item.last_update_price)          
            let _diffDays = _lastUpdateNow.diff(_lastUpdateAnt, 'days');
            let titleDays = ""
            if(_diffDays==0) {
              titleDays = "en el mismo día";
            } else if(_diffDays==1) {
              titleDays = "desde el día de ayer"
            } else {
              titleDays = "desde los últimos " + _diffDays + " días"
            }

            let _priceAnt = item.history[1].price_list                    
            let _priceNow = item.price_list              
            let _raise = ((_priceNow - _priceAnt) / _priceAnt) * 100
            let _raiseAbs = Math.abs(_raise)
            let _raisePercentWithDecimal = Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(_raiseAbs / 100)
            let _raisePercentWithoutDecimal = Intl.NumberFormat('es-AR',{style:'percent', minimumFractionDigits: 0, maximumFractionDigits: 0}).format(_raiseAbs / 100)
                                  
            if(_raise>0) {
              let title = "Aumento un " + _raisePercentWithDecimal + " con respecto al precio anterior " + titleDays;
              html = "<span style='font-size:10px; color: var(--app-color-danger); font-weight: bold; cursor: pointer;' title='" + title + "'>" + _raisePercentWithoutDecimal + "&nbsp;<span class='material-symbols-rounded' style='font-size:10px; vertical-align:-1px;'>arrow_upward</span></span>";
            } else {
              let title = "Bajo un " + _raisePercentWithDecimal + " con respecto al precio anterior " + titleDays;
              html = "<span style='font-size:10px; color: var(--app-color-success); font-weight: bold; cursor: pointer;' title='" + title + "'>" + _raisePercentWithoutDecimal + "&nbsp;<span class='material-symbols-rounded' style='font-size:10px; vertical-align:-1px;'>arrow_downward</span></span>";
            }
          }          
        }
        return html;
      },

      // ACTIVE / INACTIVE
      activateProduct(item) {
        this.confirmDialog('¿Volver a ACTIVAR el producto [' + item.code + '] - ' + item.name + '?', {
          title: 'Activar Producto',
          icon: 'toggle-on',
          okTitle: 'ACTIVAR',
        })
        .then(value => {          
          if (value) {                    
            let loader = this.$loading.show();
                
            var result = serviceAPI.activarProductsSale({
              id: item.id
            });

            result.then(() => {                            
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Producto Activado");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })                
      },
      inactivateProduct(item) {
        this.confirmDialog('¿Quieres INACTIVAR el producto [' + item.code + '] - ' + item.name + '?', {
          title: 'Inactivar Producto',
          icon: 'toggle-off',
          okTitle: 'INACTIVAR',
        })
        .then(value => {          
          if (value) {                    
            let loader = this.$loading.show();
                
            var result = serviceAPI.inactivarProductsSale({
              id: item.id
            });

            result.then(() => {                            
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Producto Inactivado");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })                
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_price_cost_suppliers_products', JSON.stringify(this.crud.formPriceSaleDefault))
      },
      restoreFilterStorage() {
        if(this.hasShowPriceSales) {
          if(Storage.getValue('filter_price_cost_suppliers_products')) {          
            this.crud.formPriceSaleDefault = JSON.parse(Storage.getValue('filter_price_cost_suppliers_products'))
          }         
        } else {
          this.crud.formPriceSaleDefault.price_list = null
          this.crud.formPriceSaleDefault.price_list_id = 0
          this.saveFilterStorage()
        }
      },      
    }       
  }
</script>
<style>
  .crud-price-list-suppliers-products-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-price-list-suppliers-products-code {
    color: var(--app-color-text-muted);
  }
  .crud-price-list-suppliers-download {
    float: left;
    margin-right: 10px;
  }
  #cost-tree-suppliers .vtl-tree-margin {
    margin-left: 10px;
  }
  #cost-tree-suppliers .vtl-node-main {
    padding: 0px 0 0px 10px;
    cursor: pointer;
  }
  #cost-tree-suppliers .vtl-node-content {
    font-size: var(--app-text-sm);
    cursor: pointer;
  }
  #cost-tree-suppliers .supplier-tree-name {
    font-weight: 700;
  }
  #cost-tree-suppliers .supplier-tree-count {
    font-weight: 400;
    color: var(--app-color-text-muted);
  }
  .cost-tree-panel-title {
    align-items: center;
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text);
    display: flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 7px;
    padding: 12px;
  }
  .cost-tree-panel-title > span {
    align-items: center;
    display: inline-flex;
    gap: 7px;
  }
  .cost-tree-panel-title .material-symbols-rounded {
    color: var(--app-color-primary);
  }
  .cost-tree-toggle.btn {
    align-items: center;
    border: 0;
    border-radius: 5px;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    height: 25px;
    justify-content: center;
    margin: -4px -5px -4px auto;
    padding: 0;
    width: 25px;
  }
  .cost-tree-toggle.btn:hover,
  .cost-tree-toggle.btn:focus {
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .cost-tree-panel-filter {
    align-items: center;
    border-bottom: 1px solid var(--app-color-border);
    display: flex;
    gap: 6px;
    padding: 10px 12px;
  }
  .cost-tree-panel-filter .v-select {
    flex: 1 1 auto;
    min-width: 0;
  }
  .cost-tree-panel-filter .vs__dropdown-toggle {
    min-height: 31px;
    padding: 0 0 2px;
  }
  .cost-tree-panel-filter .vs__selected-options {
    padding: 0 2px;
  }
  .cost-tree-panel-filter .vs__search,
  .cost-tree-panel-filter .vs__selected {
    font-size: var(--app-text-sm);
    margin-top: 2px;
  }
  .cost-tree-panel-filter .btn {
    flex-shrink: 0;
    height: 31px;
    padding: 0;
    width: 31px;
  }
  .cost-tree-suppliers-tree {
    max-height: 60vh;
    overflow: auto;
    padding: 8px 12px 12px;
  }
  .cost-tree-suppliers-tree .icon.material-symbols-rounded {
    color: var(--app-color-primary);
    font-size: 16px;
    margin-right: 5px;
    vertical-align: -3px;
  }
  .cost-tree-suppliers-tree .vtl-node-content {
    font-size: var(--app-text-sm);
  }
  /* El caret expandir/colapsar de vue-tree-list no tiene slot propio (se
     renderiza fijo en el componente) — se pisa el mismo mecanismo que
     vue-form-wizard: tipografía y contenido de Material Symbols sobre el
     ::before del ícono de la librería (ver docs/modal-interfaces/README.md,
     sección "Íconos de <tab-content>"). */
  .cost-tree-suppliers-tree .vtl-icon {
    font-family: 'Material Symbols Rounded' !important;
    font-weight: normal !important;
    font-style: normal !important;
    font-feature-settings: 'liga' !important;
    font-size: 16px;
    color: var(--app-color-text-secondary);
  }
  .cost-tree-suppliers-tree .vtl-icon-caret-down::before {
    content: 'expand_more' !important;
  }
  .cost-tree-suppliers-tree .vtl-icon-caret-right::before {
    content: 'chevron_right' !important;
  }
  /* Mientras se está trayendo la grilla de productos de un proveedor, se bloquea el
     árbol: evita que clickear varios proveedores seguidos dispare una consulta pesada
     por cada click (la anterior no se cancela, así que se acumulaban en el backend). */
  .cost-tree-suppliers-tree {
    position: relative;
  }
  .cost-tree-suppliers-tree--loading {
    pointer-events: none;
    opacity: 0.5;
  }
  .cost-tree-suppliers-tree__overlay {
    align-items: center;
    background: transparent;
    bottom: 0;
    cursor: wait;
    display: flex;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
  .cost-supplier-products-history-overflow {
    overflow: auto;
    max-height: 400px;
  }
  .cost-supplier-products-edit-overflow {
    overflow: auto;
    max-height: 450px;
  }
  .popover-price-cost-suplliers-products .popover-body hr{
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .popover-price-cost-suplliers-products .cpls-cost-final-row {
    font-size: inherit;
    line-height: 1.45;
    padding: 2px 0;
  }
  .popover-price-cost-suplliers-products .cpls-cost-final-row--no-iva {
    color: var(--app-color-text-secondary);
  }
  .popover-price-cost-suplliers-products .cpls-cost-final-row--iva {
    color: var(--app-color-primary);
    border-top: 1px solid var(--app-color-primary-soft);
    margin-top: 4px;
    padding-top: 5px;
  }
  .popover-name-cost-suplliers-products .popover-body hr{
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .price-list-editor-table tbody tr {
    cursor: pointer;
  }
  .price-list-editor-body {
    padding: 12px 14px;
  }
  .price-list-editor-item {
    padding: 12px;
  }
  .price-list-editor-header {
    gap: 8px;
  }
  .price-list-editor-header-left {
    flex: 1 1 auto;
    min-width: 0;
  }
  .price-list-editor-header-actions {
    flex: 0 0 auto;
    align-self: flex-start;
  }
  .price-list-editor-product {
    white-space: normal;
    word-break: break-word;
    line-height: 1.2;
  }
  .b-sidebar .list-group-item.price-list-editor-item:hover,
  .b-sidebar .list-group-item.price-list-editor-item:focus {
    background-color: var(--app-color-primary-soft) !important;
    color: var(--app-color-text) !important;
    border-color: var(--app-color-border) !important;
  }
  .b-sidebar .list-group-item.price-list-editor-item:hover *,
  .b-sidebar .list-group-item.price-list-editor-item:focus * {
    color: var(--app-color-text) !important;
  }
  .cost-tree-collapsed-bar {
    align-items: center;
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border-strong);
    border-radius: 6px;
    color: var(--app-color-text-secondary);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    margin: 0 15px 1rem;
    min-height: 200px;
    padding: 14px 5px;
    transition: background-color 0.15s, color 0.15s;
    width: 32px;
  }
  .cost-tree-collapsed-bar:hover {
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .cost-tree-collapsed-bar > .material-symbols-rounded {
    font-size: 18px;
    margin-bottom: 8px;
  }
  .cost-tree-collapsed-text {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: var(--app-text-xs);
    color: var(--app-color-text-secondary);
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.02em;
  }
  .cost-tree-products-expanded {
    flex: 1;
    max-width: calc(100% - 50px);
  }
  @media (max-width: 991.98px) {
    .cost-tree-collapsed-bar {
      flex-direction: row;
      justify-content: center;
      margin: 0 15px 12px;
      min-height: 32px;
      padding: 6px 10px;
      width: calc(100% - 30px);
    }
    .cost-tree-collapsed-bar > .material-symbols-rounded {
      margin: 0 5px 0 0;
    }
    .cost-tree-collapsed-text {
      writing-mode: horizontal-tb;
    }
    .cost-tree-products-expanded {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  .btn.list-view-icon-btn.cpls-options-toggle--warning {
    background: var(--app-color-warning);
  }
  .btn.list-view-icon-btn.cpls-options-toggle--warning:hover,
  .btn.list-view-icon-btn.cpls-options-toggle--warning:focus {
    background: var(--app-color-warning-hover);
  }
  .btn.cpls-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
    white-space: nowrap;
  }
  .btn.cpls-action-toggle-labeled:hover,
  .btn.cpls-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-price-list-suppliers-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
  .cpls-convert-tabs {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
  }
  .cpls-convert-tabs .nav-item {
    flex: 0 0 auto;
  }
</style>
<style scoped>
  .cpls-filters-hint {
    margin-top: 12px;
    margin-bottom: 0;
  }
  .cpls-mode-indicators {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }
  @media (max-width: 767.98px) {
    .cpls-mode-indicators {
      justify-content: flex-start;
      margin-top: 8px;
    }
  }
  .cpls-iva-toggle {
    align-items: center;
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    border-radius: 6px;
    display: inline-flex;
    height: 27px;
    padding: 0 10px;
    transition: background-color 0.15s, border-color 0.15s;
  }
  .cpls-iva-toggle .custom-control {
    line-height: 1.3;
  }
  .cpls-iva-toggle--active {
    background: var(--app-color-primary-soft);
    border-color: var(--app-color-primary-200);
  }
  @media (max-width: 767.98px) {
    .cpls-iva-toggle {
      height: 34px;
    }
  }
  .cpls-rounded-badge {
    align-items: center;
    background: var(--app-color-warning-soft);
    border: 1px solid var(--app-color-warning-border);
    border-radius: 999px;
    color: var(--app-color-warning-hover);
    cursor: default;
    display: inline-flex;
    flex-shrink: 0;
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    height: 27px;
    padding: 0 10px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
  @media (max-width: 767.98px) {
    .cpls-rounded-badge {
      height: 34px;
    }
  }
  .input-group-sm .input-group-prepend .input-group-text {
    padding: 3px;
  }
  .input-group-sm .input-group-append .btn {
    padding: 1px;
  }
  .input-group-sm .form-control {
    padding: 2px;
  }
  .dropdown-divider {
    margin: 3px;
  }
</style>
